/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/v{version}/analytics/usage": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["UsageMetricsSummary"];
                        "application/json": components["schemas"]["UsageMetricsSummary"];
                        "text/json": components["schemas"]["UsageMetricsSummary"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/curation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["CurationMetricsSummary"];
                        "application/json": components["schemas"]["CurationMetricsSummary"];
                        "text/json": components["schemas"]["CurationMetricsSummary"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/extraction-output": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionOutputMetrics"];
                        "application/json": components["schemas"]["ExtractionOutputMetrics"];
                        "text/json": components["schemas"]["ExtractionOutputMetrics"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/substance-validation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SubstanceVerificationMetrics"];
                        "application/json": components["schemas"]["SubstanceVerificationMetrics"];
                        "text/json": components["schemas"]["SubstanceVerificationMetrics"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/curation/field-changes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                    fieldKey?: string;
                    page?: number;
                    pageSize?: number;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["FieldChangeDetailResponse"];
                        "application/json": components["schemas"]["FieldChangeDetailResponse"];
                        "text/json": components["schemas"]["FieldChangeDetailResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/curation/field-value-changes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                    fieldKey?: string;
                    changeKind?: components["schemas"]["CurationChangeKind"];
                    take?: number;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["FieldValueChangeResponse"];
                        "application/json": components["schemas"]["FieldValueChangeResponse"];
                        "text/json": components["schemas"]["FieldValueChangeResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/extraction-health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionHealthMetrics"];
                        "application/json": components["schemas"]["ExtractionHealthMetrics"];
                        "text/json": components["schemas"]["ExtractionHealthMetrics"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/analytics/extraction-health/events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    From?: string;
                    To?: string;
                    TeamId?: string;
                    GroupBy?: components["schemas"]["TimeSeriesGrouping"];
                    DocumentType?: components["schemas"]["DocumentType"];
                    eventType?: string;
                    messageFilter?: string;
                    page?: number;
                    pageSize?: number;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["PageOfExtractionEventListItem"];
                        "application/json": components["schemas"]["PageOfExtractionEventListItem"];
                        "text/json": components["schemas"]["PageOfExtractionEventListItem"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/ctu-iso-codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["CtuIsoCodeEntry"][];
                        "application/json": components["schemas"]["CtuIsoCodeEntry"][];
                        "text/json": components["schemas"]["CtuIsoCodeEntry"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/dev/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    minAgeMinutes?: number;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SeededTransactionSummary"][];
                        "application/json": components["schemas"]["SeededTransactionSummary"][];
                        "text/json": components["schemas"]["SeededTransactionSummary"][];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "multipart/form-data": {
                        /** Format: binary */
                        File?: string;
                        /** Format: binary */
                        Document?: string;
                        /** Format: binary */
                        Layout?: string;
                        Artifacts?: string[];
                        DocumentType?: components["schemas"]["DocumentType"];
                        Regulations?: string[];
                        DisplayName?: string;
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SeedTransactionResponse"];
                        "application/json": components["schemas"]["SeedTransactionResponse"];
                        "text/json": components["schemas"]["SeedTransactionResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/dev/transactions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/dev/errors/trigger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["TriggerErrorRequest"];
                    "text/json": components["schemas"]["TriggerErrorRequest"];
                    "application/*+json": components["schemas"]["TriggerErrorRequest"];
                };
            };
            responses: {
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Service Unavailable */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/error-categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionErrorCategoryMetadata"][];
                        "application/json": components["schemas"]["ExtractionErrorCategoryMetadata"][];
                        "text/json": components["schemas"]["ExtractionErrorCategoryMetadata"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/errors": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ProblemTypeMetadata"][];
                        "application/json": components["schemas"]["ProblemTypeMetadata"][];
                        "text/json": components["schemas"]["ProblemTypeMetadata"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "multipart/form-data": {
                        /** Format: binary */
                        file?: string;
                        Method?: components["schemas"]["ExtractionMethod"];
                        DocumentType?: components["schemas"]["DocumentType"];
                        "PromptOverrides.DecimalSeparator"?: components["schemas"]["DecimalSeparator"];
                        /** Format: uuid */
                        ModelConfigId?: string;
                        Regulations?: string[];
                        TargetValidationId?: string;
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionResponse"];
                        "application/json": components["schemas"]["ExtractionResponse"];
                        "text/json": components["schemas"]["ExtractionResponse"];
                    };
                };
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionResponse"];
                        "application/json": components["schemas"]["ExtractionResponse"];
                        "text/json": components["schemas"]["ExtractionResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ExtractionFailedProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/extract/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "multipart/form-data": {
                        files?: string[];
                        Method?: components["schemas"]["ExtractionMethod"];
                        DocumentType?: components["schemas"]["DocumentType"];
                        "PromptOverrides.DecimalSeparator"?: components["schemas"]["DecimalSeparator"];
                        /** Format: uuid */
                        ModelConfigId?: string;
                        Regulations?: string[];
                        TargetValidationId?: string;
                    };
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["BatchUploadResponse"];
                        "application/json": components["schemas"]["BatchUploadResponse"];
                        "text/json": components["schemas"]["BatchUploadResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/extraction-models": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionModelConfigResponse"][];
                        "application/json": components["schemas"]["ExtractionModelConfigResponse"][];
                        "text/json": components["schemas"]["ExtractionModelConfigResponse"][];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["CreateExtractionModelConfigRequest"];
                    "text/json": components["schemas"]["CreateExtractionModelConfigRequest"];
                    "application/*+json": components["schemas"]["CreateExtractionModelConfigRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionModelConfigResponse"];
                        "application/json": components["schemas"]["ExtractionModelConfigResponse"];
                        "text/json": components["schemas"]["ExtractionModelConfigResponse"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/extraction-models/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionModelConfigResponse"];
                        "application/json": components["schemas"]["ExtractionModelConfigResponse"];
                        "text/json": components["schemas"]["ExtractionModelConfigResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["UpdateExtractionModelConfigRequest"];
                    "text/json": components["schemas"]["UpdateExtractionModelConfigRequest"];
                    "application/*+json": components["schemas"]["UpdateExtractionModelConfigRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionModelConfigResponse"];
                        "application/json": components["schemas"]["ExtractionModelConfigResponse"];
                        "text/json": components["schemas"]["ExtractionModelConfigResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["HealthResponse"];
                        "application/json": components["schemas"]["HealthResponse"];
                        "text/json": components["schemas"]["HealthResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/jobs/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["JobFilterRequest"];
                    "text/json": components["schemas"]["JobFilterRequest"];
                    "application/*+json": components["schemas"]["JobFilterRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["PageOfJobResponse"];
                        "application/json": components["schemas"]["PageOfJobResponse"];
                        "text/json": components["schemas"]["PageOfJobResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/jobs/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["JobResponse"];
                        "application/json": components["schemas"]["JobResponse"];
                        "text/json": components["schemas"]["JobResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/jobs/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["JobResponse"];
                        "application/json": components["schemas"]["JobResponse"];
                        "text/json": components["schemas"]["JobResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/jobs/{id}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["JobResponse"];
                        "application/json": components["schemas"]["JobResponse"];
                        "text/json": components["schemas"]["JobResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/jobs/{id}/assignee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["AssignJobRequest"];
                    "text/json": components["schemas"]["AssignJobRequest"];
                    "application/*+json": components["schemas"]["AssignJobRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["JobResponse"];
                        "application/json": components["schemas"]["JobResponse"];
                        "text/json": components["schemas"]["JobResponse"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/preview/page/{pageNumber}.png": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    pageNumber: number;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/regulations/choices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    validationId?: string;
                    documentType?: components["schemas"]["DocumentType"];
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["RegulationChoicesResponse"];
                        "application/json": components["schemas"]["RegulationChoicesResponse"];
                        "text/json": components["schemas"]["RegulationChoicesResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/substances/verifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SubstanceVerificationRequest"];
                    "text/json": components["schemas"]["SubstanceVerificationRequest"];
                    "application/*+json": components["schemas"]["SubstanceVerificationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SubstanceVerificationResponse"];
                        "application/json": components["schemas"]["SubstanceVerificationResponse"];
                        "text/json": components["schemas"]["SubstanceVerificationResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/substances/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SubstanceSingleResponse"];
                        "application/json": components["schemas"]["SubstanceSingleResponse"];
                        "text/json": components["schemas"]["SubstanceSingleResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/substances/rank": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["RankSubstancesRequest"];
                    "text/json": components["schemas"]["RankSubstancesRequest"];
                    "application/*+json": components["schemas"]["RankSubstancesRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["RankedSubstanceResponse"];
                        "application/json": components["schemas"]["RankedSubstanceResponse"];
                        "text/json": components["schemas"]["RankedSubstanceResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/substances/hierarchy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["PackagingHierarchyRequest"];
                    "text/json": components["schemas"]["PackagingHierarchyRequest"];
                    "application/*+json": components["schemas"]["PackagingHierarchyRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["PackagingHierarchyResponse"];
                        "application/json": components["schemas"]["PackagingHierarchyResponse"];
                        "text/json": components["schemas"]["PackagingHierarchyResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/support/error-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SupportReportRequest"];
                    "text/json": components["schemas"]["SupportReportRequest"];
                    "application/*+json": components["schemas"]["SupportReportRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SupportReportResponse"];
                        "application/json": components["schemas"]["SupportReportResponse"];
                        "text/json": components["schemas"]["SupportReportResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/support/feedback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "multipart/form-data": {
                        FeedbackText: string;
                        /** Format: binary */
                        Screenshot?: string;
                        TransactionId?: string;
                        TransactionUrl?: string;
                        IncludeSourceDocument?: boolean;
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["FeedbackSubmissionResponse"];
                        "application/json": components["schemas"]["FeedbackSubmissionResponse"];
                        "text/json": components["schemas"]["FeedbackSubmissionResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": string[];
                        "application/json": string[];
                        "text/json": string[];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/model-assignments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamModelAssignmentResponse"][];
                        "application/json": components["schemas"]["TeamModelAssignmentResponse"][];
                        "text/json": components["schemas"]["TeamModelAssignmentResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamMemberResponse"][];
                        "application/json": components["schemas"]["TeamMemberResponse"][];
                        "text/json": components["schemas"]["TeamMemberResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamSettingsResponse"];
                        "application/json": components["schemas"]["TeamSettingsResponse"];
                        "text/json": components["schemas"]["TeamSettingsResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["UpdateTeamSettingsRequest"];
                    "text/json": components["schemas"]["UpdateTeamSettingsRequest"];
                    "application/*+json": components["schemas"]["UpdateTeamSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamSettingsResponse"];
                        "application/json": components["schemas"]["TeamSettingsResponse"];
                        "text/json": components["schemas"]["TeamSettingsResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["CreateTeamSettingsRequest"];
                    "text/json": components["schemas"]["CreateTeamSettingsRequest"];
                    "application/*+json": components["schemas"]["CreateTeamSettingsRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamSettingsResponse"];
                        "application/json": components["schemas"]["TeamSettingsResponse"];
                        "text/json": components["schemas"]["TeamSettingsResponse"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/settings/models": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["UpdateTeamModelSelectionRequest"];
                    "text/json": components["schemas"]["UpdateTeamModelSelectionRequest"];
                    "application/*+json": components["schemas"]["UpdateTeamModelSelectionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TeamSettingsResponse"];
                        "application/json": components["schemas"]["TeamSettingsResponse"];
                        "text/json": components["schemas"]["TeamSettingsResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    Page?: number;
                    PageSize?: number;
                    Cursor?: string;
                    Status?: components["schemas"]["TransactionStatus"];
                    StartDate?: string;
                    EndDate?: string;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["PageOfTransactionResponse"];
                        "application/json": components["schemas"]["PageOfTransactionResponse"];
                        "text/json": components["schemas"]["PageOfTransactionResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    validationId?: string;
                };
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ResolveValidationResponse"];
                        "application/json": components["schemas"]["ResolveValidationResponse"];
                        "text/json": components["schemas"]["ResolveValidationResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    include?: string;
                };
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TransactionWithArtifactsResponse"];
                        "application/json": components["schemas"]["TransactionWithArtifactsResponse"];
                        "text/json": components["schemas"]["TransactionWithArtifactsResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/regulations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["RegulationsDto"];
                        "application/json": components["schemas"]["RegulationsDto"];
                        "text/json": components["schemas"]["RegulationsDto"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["RegulationsDto"];
                    "text/json": components["schemas"]["RegulationsDto"];
                    "application/*+json": components["schemas"]["RegulationsDto"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["RegulationsDto"];
                        "application/json": components["schemas"]["RegulationsDto"];
                        "text/json": components["schemas"]["RegulationsDto"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/pdf": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/artifacts/{name}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    name: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/curation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SaveCuratedDataRequest"];
                    "text/json": components["schemas"]["SaveCuratedDataRequest"];
                    "application/*+json": components["schemas"]["SaveCuratedDataRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["TransactionResponse"];
                        "application/json": components["schemas"]["TransactionResponse"];
                        "text/json": components["schemas"]["TransactionResponse"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SaveCuratedDataRequest"];
                    "text/json": components["schemas"]["SaveCuratedDataRequest"];
                    "application/*+json": components["schemas"]["SaveCuratedDataRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExportResponse"];
                        "application/json": components["schemas"]["ExportResponse"];
                        "text/json": components["schemas"]["ExportResponse"];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/export/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["WebhookPayload"];
                        "application/json": components["schemas"]["WebhookPayload"];
                        "text/json": components["schemas"]["WebhookPayload"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/error-checks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["DeltaCheckErrorsRequest"];
                    "text/json": components["schemas"]["DeltaCheckErrorsRequest"];
                    "application/*+json": components["schemas"]["DeltaCheckErrorsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ErrorReport"];
                        "application/json": components["schemas"]["ErrorReport"];
                        "text/json": components["schemas"]["ErrorReport"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/error-checks/initial": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ErrorReport"];
                        "application/json": components["schemas"]["ErrorReport"];
                        "text/json": components["schemas"]["ErrorReport"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/error-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ErrorReviewResponse"];
                        "application/json": components["schemas"]["ErrorReviewResponse"];
                        "text/json": components["schemas"]["ErrorReviewResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{id}/re-extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ExtractionResponse"];
                        "application/json": components["schemas"]["ExtractionResponse"];
                        "text/json": components["schemas"]["ExtractionResponse"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ExtractionFailedProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/validation-request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["CreateValidationRequest"];
                    "text/json": components["schemas"]["CreateValidationRequest"];
                    "application/*+json": components["schemas"]["CreateValidationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ValidationRequestResponse"];
                        "application/json": components["schemas"]["ValidationRequestResponse"];
                        "text/json": components["schemas"]["ValidationRequestResponse"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/compatibility-checks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SubmitValidationRequest"];
                    "text/json": components["schemas"]["SubmitValidationRequest"];
                    "application/*+json": components["schemas"]["SubmitValidationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["CompatibilityCheckResponse"];
                        "application/json": components["schemas"]["CompatibilityCheckResponse"];
                        "text/json": components["schemas"]["CompatibilityCheckResponse"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/compatibility-checks/form": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["FormCompatibilityCheckRequest"];
                    "text/json": components["schemas"]["FormCompatibilityCheckRequest"];
                    "application/*+json": components["schemas"]["FormCompatibilityCheckRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["FormCompatibilityCheckResponse"];
                        "application/json": components["schemas"]["FormCompatibilityCheckResponse"];
                        "text/json": components["schemas"]["FormCompatibilityCheckResponse"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/merge-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["MergePreviewRequest"];
                    "text/json": components["schemas"]["MergePreviewRequest"];
                    "application/*+json": components["schemas"]["MergePreviewRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["MergePreviewResponse"];
                        "application/json": components["schemas"]["MergePreviewResponse"];
                        "text/json": components["schemas"]["MergePreviewResponse"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/transactions/{transactionId}/validations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    transactionId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["SubmitValidationRequest"];
                    "text/json": components["schemas"]["SubmitValidationRequest"];
                    "application/*+json": components["schemas"]["SubmitValidationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["SaveValidationResponse"];
                        "application/json": components["schemas"]["SaveValidationResponse"];
                        "text/json": components["schemas"]["SaveValidationResponse"];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HazcheckValidationProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/users/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["UserProfileResponse"];
                        "application/json": components["schemas"]["UserProfileResponse"];
                        "text/json": components["schemas"]["UserProfileResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/validations/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ValidationSummaryResponse"];
                        "application/json": components["schemas"]["ValidationSummaryResponse"];
                        "text/json": components["schemas"]["ValidationSummaryResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/validations/{id}/sources": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["ValidationSourcesResponse"];
                        "application/json": components["schemas"]["ValidationSourcesResponse"];
                        "text/json": components["schemas"]["ValidationSourcesResponse"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/webhook/tests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": components["schemas"]["WebhookTestRequest"];
                    "text/json": components["schemas"]["WebhookTestRequest"];
                    "application/*+json": components["schemas"]["WebhookTestRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["WebhookTestResponse"];
                        "application/json": components["schemas"]["WebhookTestResponse"];
                        "text/json": components["schemas"]["WebhookTestResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/webhook/deliveries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    page?: number;
                    pageSize?: number;
                    status?: string;
                    eventType?: string;
                    transactionId?: string;
                };
                header?: never;
                path: {
                    teamId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["PageOfWebhookDeliveryListItem"];
                        "application/json": components["schemas"]["PageOfWebhookDeliveryListItem"];
                        "text/json": components["schemas"]["PageOfWebhookDeliveryListItem"];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/webhook/deliveries/{deliveryId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    deliveryId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["WebhookDeliveryDetail"];
                        "application/json": components["schemas"]["WebhookDeliveryDetail"];
                        "text/json": components["schemas"]["WebhookDeliveryDetail"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v{version}/teams/{teamId}/webhook/deliveries/{deliveryId}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    teamId: string;
                    deliveryId: string;
                    version: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "text/plain": components["schemas"]["WebhookDeliveryDetail"];
                        "application/json": components["schemas"]["WebhookDeliveryDetail"];
                        "text/json": components["schemas"]["WebhookDeliveryDetail"];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        ArtifactInfo: {
            name?: components["schemas"]["ArtifactName"];
            filename?: string | null;
            exists?: boolean;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        ArtifactName: ArtifactName;
        AssignJobRequest: {
            assignedToId?: string | null;
        };
        BatchUploadResponse: {
            jobs: components["schemas"]["JobCreatedResponse"][];
        };
        CargoBbox: {
            pages?: components["schemas"]["CargoBboxPage"][] | null;
        };
        CargoBboxPage: {
            /** Format: int32 */
            pageNo?: number;
            /** Format: int32 */
            width?: number;
            /** Format: int32 */
            height?: number;
            sections?: components["schemas"]["CargoBboxSection"][] | null;
        };
        CargoBboxRow: {
            /** Format: int32 */
            pageNo?: number;
            label?: string | null;
            /** Format: double */
            score?: number | null;
            boundingBox?: number[] | null;
        };
        CargoBboxSection: {
            /** Format: int32 */
            pageNo?: number;
            /** Format: int32 */
            sectionIdx?: number;
            label?: string | null;
            /** Format: double */
            score?: number | null;
            boundingBox?: number[] | null;
            rows?: components["schemas"]["CargoBboxRow"][] | null;
        };
        CargoDescription: {
            text?: string | null;
            source?: string | null;
        };
        CargoDevMeta: {
            /** Format: int32 */
            ctuIndex?: number;
            ctuLabel?: string | null;
            edited?: boolean;
        };
        /** @enum {string} */
        CargoFieldName: CargoFieldName;
        CargoItem: {
            description?: components["schemas"]["CargoDescription"][] | null;
            weight?: components["schemas"]["CargoWeight"];
            packaging?: components["schemas"]["Packaging"];
            unNumber?: string | null;
            properShippingName?: string | null;
            technicalName?: string | null;
            hazardClass?: string | null;
            subsidiaryHazard?: string[] | null;
            packingGroup?: string | null;
            isMarinePollutant?: boolean | null;
            isLimitedQuantity?: boolean | null;
            isWaste?: boolean | null;
            isExceptedQuantity?: boolean | null;
            isEmptyUncleaned?: boolean | null;
            isSalvage?: boolean | null;
            isHot?: boolean | null;
            /** Format: double */
            flashpoint?: number | null;
            flashpointModifier?: string | null;
            emsNumber?: string | null;
            segregationGroup?: string | null;
            cargoId?: string | null;
            /** Format: int32 */
            pageNo?: number | null;
            /** Format: int32 */
            sectionIdx?: number | null;
            shipperConsignee?: string | null;
            saidToContain?: string | null;
            idNumberPrefix?: string | null;
            isReportableQuantity?: boolean | null;
            emergencyContact?: components["schemas"]["DcmEmergencyContact"];
            cargoDestination?: string | null;
            loadPort?: string | null;
            specialNotes?: string | null;
            grossWeight?: components["schemas"]["WeightValue"];
            rawSourceFields?: {
                unNumber?: string;
                properShippingName?: string;
                technicalName?: string;
                hazardClass?: string;
                packingGroup?: string;
                subsidiaryRisk?: string;
                emsNumber?: string;
                substanceId?: string;
                netWeight?: string;
                grossWeight?: string;
                netExplosiveContent?: string;
                weight?: string;
                outerPackaging?: string;
                outerPackagingCount?: string;
                innerPackaging?: string;
                innerPackagingCount?: string;
                saidToContain?: string;
                flashpoint?: string;
                additionalSegregationGroups?: string;
                capacity?: string;
                actualDgWeight?: string;
                dsitCode?: string;
                fireworkClassificationCode?: string;
                t75EndOfHoldingTime?: string;
                dateOfPacking?: string;
                dateOfProduction?: string;
                carbonOfOrganicOriginTemperature?: string;
                controlTemperature?: string;
                emergencyTemperature?: string;
                isMarinePollutant?: string;
                isLimitedQuantity?: string;
                emergencyContactName?: string;
                emergencyContactPhone?: string;
                fumigantName?: string;
                fumigationDateTime?: string;
                fumigantDosage?: string;
                radionuclide?: string;
                descriptionOfMaterial?: string;
                radioactivity?: string;
                radioactiveCategory?: string;
                transportIndex?: string;
                criticalitySafetyIndex?: string;
            } | null;
        };
        CargoResult: {
            cargoReference: string;
            messages: components["schemas"]["ValidationMessage"][];
            warningSignage: components["schemas"]["WarningSignage"][];
        };
        CargoSectionDebug: {
            /** Format: int32 */
            pages?: number;
            /** Format: int32 */
            cropsSent?: number;
            /** Format: int32 */
            containerCropsSent?: number;
            targetLabels?: string[] | null;
        };
        CargoSectionResult: {
            cargoTransportUnits?: components["schemas"]["CargoTransportUnit"][] | null;
            containerSections?: components["schemas"]["CargoTransportUnit"][] | null;
            cargoBbox?: components["schemas"]["CargoBbox"];
            debug?: components["schemas"]["CargoSectionDebug"];
            layoutDetection?: components["schemas"]["LayoutDetectionResult"];
            /** Format: int32 */
            promptTokens?: number;
            /** Format: int32 */
            candidateTokens?: number;
            /** Format: int32 */
            totalTokens?: number;
        };
        CargoTransportUnit: {
            type?: string | null;
            cargo?: components["schemas"]["CargoItem"][] | null;
            weight?: components["schemas"]["CargoWeight"];
            containerNumber?: string | null;
            containerType?: string | null;
            sealNumbers?: string[] | null;
            stowagePosition?: string | null;
        };
        CargoTransportUnitDto: {
            ctuId: string;
            ctuReference?: string | null;
            /** Format: int32 */
            unitType?: number | null;
            containerInformation?: components["schemas"]["ContainerInformationDto"];
            stowagePosition?: string | null;
        };
        CargoTransportUnitResult: {
            ctuReference: string;
            messages: components["schemas"]["ValidationMessage"][];
            cargo: components["schemas"]["CargoResult"][];
            warningSignage: components["schemas"]["WarningSignage"][];
            stowageSegregationComments: components["schemas"]["StowageSegregationComment"][];
            segregationClashes: components["schemas"]["SegregationClash"][];
        };
        CargoWeight: {
            netWeight?: components["schemas"]["WeightValue"];
            grossWeight?: components["schemas"]["WeightValue"];
            nec?: components["schemas"]["WeightValue"];
        };
        Cfr49AdditionalRequirements: {
            pihDeclarationRequired?: boolean;
            pihZoneRequired?: boolean;
            requiresEXNumber?: boolean;
            hasReportableQuantityLimit?: boolean;
            requiresFlashpoint?: boolean;
        };
        Cfr49Substance: {
            substanceId?: string | null;
            unNumber?: string | null;
            technicalNameRequired?: boolean;
            additionalRequirements?: components["schemas"]["Cfr49AdditionalRequirements"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            regulation: Cfr49SubstanceRegulation;
        };
        /** @enum {string} */
        CompatibilityCheckKind: CompatibilityCheckKind;
        CompatibilityCheckResponse: {
            requestId?: string | null;
            checkKind: components["schemas"]["CompatibilityCheckKind"];
            overallStatus: string;
            /** Format: int32 */
            totalSubstances?: number;
            /** Format: int32 */
            compatibleSubstances?: number;
            /** Format: int32 */
            incompatibleSubstances?: number;
            /** Format: int32 */
            violationsCount?: number;
            /** Format: int32 */
            warningsCount?: number;
            validationUrl?: string | null;
            rawResponse?: unknown;
            /** Format: date-time */
            submittedAt?: string;
            messages: components["schemas"]["ValidationMessage"][];
            cargoTransportUnits: components["schemas"]["CargoTransportUnitResult"][];
            segregationClashes: components["schemas"]["SegregationClash"][];
            archivedValidationId?: string | null;
        };
        ContainerDetails: {
            containerType?: string | null;
            containerSize?: string | null;
            /** Format: double */
            tareWeight?: number | null;
            /** Format: double */
            maxGrossWeight?: number | null;
            containerPackingCertificate?: components["schemas"]["ContainerPackingCertificate"];
        };
        ContainerInformationDto: {
            isoCode?: string | null;
            size?: string | null;
            /** Format: double */
            grossWeight?: number | null;
            /** Format: double */
            tareMassKg?: number | null;
            /** Format: double */
            maxGrossWeightKg?: number | null;
            /** Format: double */
            volumeInM3?: number | null;
            containerNumber?: string | null;
            sealNumber?: string | null;
        };
        ContainerPackingCertificate: {
            signed?: boolean | null;
            date?: string | null;
            place?: string | null;
            signatoryName?: string | null;
            signatoryPosition?: string | null;
            company?: string | null;
        };
        CreateExtractionModelConfigRequest: {
            codeName?: string | null;
            providerType?: components["schemas"]["ExtractionProviderType"];
            modelName?: string | null;
            baseUrl?: string | null;
            apiKey?: string | null;
            layoutAssistedExtraction?: boolean;
            requiresBackgroundExecution?: boolean;
            enabled?: boolean;
        };
        CreateTeamSettingsRequest: {
            hazcheckConfig?: components["schemas"]["HazcheckConfigDto"];
            webhookConfig?: components["schemas"]["WebhookConfigDto"];
            defaultExtractionMethod?: components["schemas"]["ExtractionMethod"];
            transactionNameSource?: components["schemas"]["TransactionNameSource"];
            exportDestination?: components["schemas"]["ExportDestination"];
            allowGenericPackagingFallback?: boolean | null;
            allowFailover?: boolean | null;
            /** Format: int32 */
            failoverAfterAttempts?: number | null;
            workflowFormConfig?: components["schemas"]["WorkflowFormConfigDto"];
            extractionPromptDefaults?: components["schemas"]["ExtractionPromptConfigPatch"];
        };
        CreateValidationRequest: {
            substances?: components["schemas"]["SubstanceForValidation"][] | null;
            cargoTransportUnits?: components["schemas"]["CargoTransportUnitDto"][] | null;
            metadata?: components["schemas"]["ValidationMetadata"];
        };
        /** @enum {string} */
        CtuFieldName: CtuFieldName;
        CtuIsoCodeEntry: {
            isoCode?: string | null;
            oldIsoCode?: string | null;
            description?: string | null;
        };
        CuratedArtifactResponse: {
            form_data?: components["schemas"]["ValidationFormData"];
            metadata?: components["schemas"]["ValidationMetadata"];
            validation_results?: components["schemas"]["CuratedValidationResult"][] | null;
            reconciled?: boolean;
        };
        CuratedCargoItem: {
            unNumber?: string | null;
            properShippingName?: string | null;
            hazardClass?: string | null;
            packingGroup?: string | null;
            technicalName?: string | null;
            subsidiaryHazards?: string[] | null;
            technicalOrChemicalName?: string | null;
            fireworkClassificationCode?: string | null;
            dsitCode?: string | null;
            t75EndOfHoldingTime?: string | null;
            controlTemperature?: components["schemas"]["FormTemperature"];
            emergencyTemperature?: components["schemas"]["FormTemperature"];
            radioactivityDetails?: components["schemas"]["FormRadioactivityDetails"];
            fumigationDetails?: components["schemas"]["FormFumigationDetails"];
            carbonOfOrganicOriginDeclarationDetails?: components["schemas"]["FormCarbonOfOrganicOriginDeclarationDetails"];
            cargoId?: string | null;
            substanceId?: string | null;
            description?: components["schemas"]["CargoDescription"][] | null;
            weights?: components["schemas"]["WeightDetails"];
            quantity?: string | null;
            packaging?: components["schemas"]["CuratedPackaging"];
            flashpoint?: components["schemas"]["FlashpointInfo"];
            declarationParameters?: components["schemas"]["FormDeclarationParameters"];
            emsNumber?: string | null;
            additionalSegregationGroups?: string[] | null;
            emergencyContact?: components["schemas"]["EmergencyContactInfo"];
            dcm?: components["schemas"]["DcmCargoFields"];
            rawSourceFields?: {
                unNumber?: string;
                properShippingName?: string;
                technicalName?: string;
                hazardClass?: string;
                packingGroup?: string;
                subsidiaryRisk?: string;
                emsNumber?: string;
                substanceId?: string;
                netWeight?: string;
                grossWeight?: string;
                netExplosiveContent?: string;
                weight?: string;
                outerPackaging?: string;
                outerPackagingCount?: string;
                innerPackaging?: string;
                innerPackagingCount?: string;
                saidToContain?: string;
                flashpoint?: string;
                additionalSegregationGroups?: string;
                capacity?: string;
                actualDgWeight?: string;
                dsitCode?: string;
                fireworkClassificationCode?: string;
                t75EndOfHoldingTime?: string;
                dateOfPacking?: string;
                dateOfProduction?: string;
                carbonOfOrganicOriginTemperature?: string;
                controlTemperature?: string;
                emergencyTemperature?: string;
                isMarinePollutant?: string;
                isLimitedQuantity?: string;
                emergencyContactName?: string;
                emergencyContactPhone?: string;
                fumigantName?: string;
                fumigationDateTime?: string;
                fumigantDosage?: string;
                radionuclide?: string;
                descriptionOfMaterial?: string;
                radioactivity?: string;
                radioactiveCategory?: string;
                transportIndex?: string;
                criticalitySafetyIndex?: string;
            } | null;
            /** Format: int32 */
            pageNo?: number | null;
            /** Format: int32 */
            sectionIdx?: number | null;
        };
        CuratedCargoTransportUnit: {
            ctuId: string;
            ctuReference?: string | null;
            /** @enum {string|null} */
            unitType?: CuratedCargoTransportUnitUnitType;
            containerInformation?: components["schemas"]["ContainerInformationDto"];
            stowagePosition?: string | null;
            cargo?: components["schemas"]["CuratedCargoItem"][] | null;
        };
        CuratedDocument: {
            documentType?: components["schemas"]["DocumentType"];
            referenceNumbers?: components["schemas"]["ReferenceNumbers"];
            imdgAmendment?: string | null;
            parties?: components["schemas"]["Parties"];
            transport?: components["schemas"]["Transport"];
            containerPackingCertificate?: components["schemas"]["ContainerPackingCertificate"];
            declaration?: components["schemas"]["Declaration"];
            emergencyContacts?: components["schemas"]["EmergencyContactInfo"][] | null;
            specialInstructions?: string | null;
            itinerary?: components["schemas"]["DcmItinerary"];
            cargoTransportUnits?: components["schemas"]["CuratedCargoTransportUnit"][] | null;
        };
        CuratedPackaging: {
            code?: string | null;
            description?: string | null;
            /** Format: int32 */
            count?: number | null;
            type?: string | null;
            inner?: components["schemas"]["PackagingDetail"];
            original?: components["schemas"]["Packaging"];
        };
        CuratedValidationResult: {
            unNumber?: string | null;
            queryParams?: components["schemas"]["QueryParams"];
            finalFilter?: string | null;
            url?: string | null;
            /** Format: int32 */
            substanceCount?: number;
            substanceIds?: string[] | null;
            substances?: components["schemas"]["SubstanceSummary"][] | null;
            /** Format: int32 */
            unrefinedSubstanceCount?: number;
            unrefinedSubstanceIds?: string[] | null;
            validationStatus?: components["schemas"]["SubstanceVerificationStatus"];
            autoSelectedSubstanceId?: string | null;
            selectedSubstanceId?: string | null;
            cargoId?: string | null;
            substanceGroupKey?: string | null;
            error?: string | null;
            errorCode?: components["schemas"]["ProblemSlug"];
            packagingValidation?: components["schemas"]["PackagingVerificationResult"];
        };
        /** @enum {string} */
        CurationChangeKind: CurationChangeKind;
        CurationMetricsSummary: {
            /** Format: int32 */
            totalExtractions?: number;
            /** Format: int32 */
            curatedExtractions?: number;
            /** Format: double */
            percentRequiringCuration?: number;
            /** Format: double */
            avgFieldChangesPerCuration?: number;
            /** Format: int32 */
            totalFieldChanges?: number;
            topChangedFields: components["schemas"]["FieldChangeFrequency"][];
            timeSeries?: components["schemas"]["TimeSeriesDataPointOfCurationMetricsSummary"][] | null;
        };
        /** @enum {string} */
        CustomRuleKind: CustomRuleKind;
        CustomRuleNote: {
            kind: components["schemas"]["CustomRuleKind"];
            name: string;
            exemptionMessage?: string | null;
            originalSeverity?: string | null;
            reason: components["schemas"]["CustomRuleReason"][];
            updatedBy?: string | null;
            updatedAt?: string | null;
        };
        CustomRuleReason: {
            label: string;
            value: string;
        };
        DangerousCargoManifest: {
            cargoTransportUnits?: components["schemas"]["CargoTransportUnit"][] | null;
            itinerary?: components["schemas"]["DcmItinerary"];
            cargoSourceLines?: {
                [key: string]: components["schemas"]["DcmSourceLineRange"];
            } | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            documentType: DangerousCargoManifestDocumentType;
        };
        DangerousGoodsDocument: {
            cargoTransportUnits?: components["schemas"]["CargoTransportUnit"][] | null;
            referenceNumbers?: components["schemas"]["ReferenceNumbers"];
            imdgAmendment?: string | null;
            parties?: components["schemas"]["Parties"];
            transport?: components["schemas"]["Transport"];
            containerDetails?: components["schemas"]["ContainerDetails"];
            emergencyContact?: components["schemas"]["EmergencyContactInfo"][] | null;
            specialInstructions?: string | null;
            declaration?: components["schemas"]["Declaration"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            documentType: DangerousGoodsDocumentDocumentType;
        };
        DcmCargoFields: {
            shipperConsignee?: string | null;
            saidToContain?: string | null;
            idNumberPrefix?: string | null;
            isReportableQuantity?: boolean | null;
            cargoDestination?: string | null;
            loadPort?: string | null;
            specialNotes?: string | null;
            /** Format: int32 */
            sourceLineStart?: number | null;
            /** Format: int32 */
            sourceLineEnd?: number | null;
        };
        DcmEmergencyContact: {
            phone?: string | null;
            company?: string | null;
        };
        DcmFormFields: {
            itinerary?: components["schemas"]["DcmItineraryFormData"];
        };
        DcmItinerary: {
            vesselName?: string | null;
            voyageNumber?: string | null;
            nationality?: string | null;
            officialNumber?: string | null;
            departurePort?: string | null;
            datePrepared?: string | null;
            terminalName?: string | null;
            portSegments?: components["schemas"]["DcmPortSegment"][] | null;
        };
        DcmItineraryFormData: {
            nationality?: string | null;
            officialNumber?: string | null;
            datePrepared?: string | null;
            terminalName?: string | null;
            portSegments?: components["schemas"]["DcmPortSegmentFormData"][] | null;
        };
        DcmPortSegment: {
            departurePort?: string | null;
            voyageNumber?: string | null;
            cargoDestinations?: string[] | null;
        };
        DcmPortSegmentFormData: {
            departurePort?: string | null;
            voyageNumber?: string | null;
            cargoDestinations?: string[] | null;
        };
        DcmSourceLineRange: {
            /** Format: int32 */
            start?: number;
            /** Format: int32 */
            end?: number;
        };
        /** @enum {string} */
        DecimalSeparator: DecimalSeparator;
        Declaration: {
            signed?: boolean | null;
            date?: string | null;
            place?: string | null;
            signatoryName?: string | null;
            signatoryPosition?: string | null;
            company?: string | null;
        };
        DeclarationParams: {
            isCoolant?: boolean | null;
            isConditioner?: boolean | null;
            isHot?: boolean | null;
            isMolten?: boolean | null;
            isStabilized?: boolean | null;
            isMarinePollutant?: boolean | null;
            isWaste?: boolean | null;
            isEmptyUncleaned?: boolean | null;
            isLimitedQuantity?: boolean | null;
            isExceptedQuantity?: boolean | null;
            isSalvagePackaging?: boolean | null;
            isSalvagePressureReceptacle?: boolean | null;
            isMixture?: boolean | null;
            isSolution?: boolean | null;
            isSample?: boolean | null;
            isFoodstuffs?: boolean | null;
            isStabilizedNotByTemperatureControl?: boolean | null;
            isReportableQuantity?: boolean | null;
            isPoisonInhalationHazard?: boolean | null;
            isWettedOrDesensitized?: boolean | null;
        };
        DeltaCheckErrorsRequest: {
            changedCargo?: components["schemas"]["FormDangerousGoodsItem"][] | null;
            changedCtus?: components["schemas"]["CargoTransportUnitDto"][] | null;
            cargoIds?: string[] | null;
            ctuIds?: string[] | null;
        };
        DetectedRegion: {
            label?: string | null;
            /** Format: double */
            score?: number;
            boundingBox?: number[] | null;
        };
        DgdFormFields: {
            containerPackingCertificate?: components["schemas"]["ContainerPackingCertificate"];
            emergencyContacts?: components["schemas"]["FormEmergencyContact"][] | null;
            declaration?: components["schemas"]["Declaration"];
        };
        DocumentEventData: {
            /** Format: int32 */
            readonly version?: number;
            /** Format: uuid */
            transactionId: string;
            filename: string | null;
            extractionMethod?: string | null;
            document?: components["schemas"]["CuratedDocument"];
            errorReport?: components["schemas"]["ErrorReport"];
        };
        /** @enum {string} */
        DocumentJobStatus: DocumentJobStatus;
        /** @enum {string} */
        DocumentType: DocumentType;
        EmergencyContact: {
            name?: string | null;
            number?: string | null;
        };
        EmergencyContactInfo: {
            name?: string | null;
            methods?: components["schemas"]["EmergencyContactMethod"][] | null;
            contract?: string | null;
            available247?: boolean | null;
        };
        EmergencyContactMethod: {
            number?: string | null;
            email?: string | null;
            description?: string | null;
        };
        EmergencySchedule: {
            schedule?: string | null;
            provisionApplies?: boolean;
        };
        EmergencySchedules: {
            fire?: components["schemas"]["EmergencySchedule"];
            spillage?: components["schemas"]["EmergencySchedule"];
        };
        ErrorBreakdownCargoField: {
            field: components["schemas"]["CargoFieldName"];
            label: string;
            severity: components["schemas"]["IssueSeverity"];
            message?: string | null;
        };
        ErrorBreakdownCargoItem: {
            cargoId: string;
            label: string;
            status: string;
            fields: components["schemas"]["ErrorBreakdownCargoField"][];
        };
        ErrorBreakdownCtuField: {
            field: components["schemas"]["CtuFieldName"];
            label: string;
            severity: components["schemas"]["IssueSeverity"];
            message?: string | null;
        };
        ErrorBreakdownEntry: {
            ctuId: string;
            label: string;
            /** Format: int32 */
            errorCount?: number;
            /** Format: int32 */
            warningCount?: number;
            /** Format: int32 */
            itemCount?: number;
            items: components["schemas"]["ErrorBreakdownCargoItem"][];
            ctuFields: components["schemas"]["ErrorBreakdownCtuField"][];
        };
        ErrorReport: {
            /** Format: int32 */
            totalCargoItems?: number;
            /** Format: int32 */
            readyCount?: number;
            /** Format: int32 */
            needsAttentionCount?: number;
            /** Format: int32 */
            errorCount?: number;
            /** Format: int32 */
            warningCount?: number;
            /** Format: int32 */
            autoFixableCount?: number;
            documentWarnings: string[];
            breakdown: components["schemas"]["ErrorBreakdownEntry"][];
            errorCountPerCargo?: {
                [key: string]: number;
            } | null;
            warningCountPerCargo?: {
                [key: string]: number;
            } | null;
            severityPerCargo?: {
                [key: string]: string;
            } | null;
            /** Format: int32 */
            errorCargoCount?: number | null;
            /** Format: int32 */
            warnCargoCount?: number | null;
            /** Format: int32 */
            editedCargoCount?: number | null;
            comparisons?: {
                [key: string]: components["schemas"]["SubstanceComparisonData"];
            } | null;
            addOnAnswers?: {
                [key: string]: {
                    [key: string]: {
                        [key: string]: components["schemas"]["RequirementAnswer"];
                    };
                };
            } | null;
        };
        ErrorReviewResponse: {
            formData: components["schemas"]["ValidationFormData"];
            extractedGoods: components["schemas"]["FormDangerousGoodsItem"][];
            metadata?: components["schemas"]["ValidationMetadata"];
            validationResults: components["schemas"]["CuratedValidationResult"][];
            enrichedSubstances?: {
                [key: string]: components["schemas"]["ImdgSubstance"];
            } | null;
            errorReport: components["schemas"]["ErrorReport"];
        };
        /** @enum {string} */
        ExportDestination: ExportDestination;
        ExportResponse: {
            /** Format: uuid */
            deliveryId?: string;
        };
        ExtractedDocument: {
            cargoTransportUnits?: components["schemas"]["CargoTransportUnit"][] | null;
            /** Format: int32 */
            documentType: number;
        } & (components["schemas"]["DangerousGoodsDocument"] | components["schemas"]["DangerousCargoManifest"]);
        /** @enum {string} */
        ExtractionErrorCategory: ExtractionErrorCategory;
        ExtractionErrorCategoryMetadata: {
            category?: components["schemas"]["ExtractionErrorCategory"];
            summary?: string | null;
            userMessage?: string | null;
            retryable?: boolean;
            reportable?: boolean;
        };
        ExtractionErrorDetail: {
            eventType: string;
            message: string;
            /** Format: int32 */
            count?: number;
        };
        ExtractionEventListItem: {
            /** Format: uuid */
            transactionId?: string | null;
            filename: string;
            teamId?: string | null;
            eventType: string;
            errorMessage?: string | null;
            extractionMethod?: string | null;
            /** Format: int32 */
            pageCount?: number | null;
            /** Format: date-time */
            createdAt?: string;
        };
        ExtractionFailedProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errorCategory?: components["schemas"]["ExtractionErrorCategory"];
            transactionId?: string | null;
            jobId?: string | null;
        } & {
            [key: string]: unknown;
        };
        ExtractionHealthMetrics: {
            /** Format: int32 */
            totalExtractions?: number;
            /** Format: int32 */
            downgradeCount?: number;
            /** Format: double */
            downgradeRate?: number;
            errorsByCategory: {
                [key: string]: number;
            };
            /** Format: int32 */
            totalErrors?: number;
            /** Format: double */
            errorRate?: number;
            /** Format: int32 */
            retryCount?: number;
            /** Format: double */
            retryRate?: number;
            /** Format: int32 */
            retrySuccessCount?: number;
            /** Format: double */
            retrySuccessRate?: number;
            /** Format: int32 */
            failureCount?: number;
            /** Format: double */
            failureRate?: number;
            errorDetails: components["schemas"]["ExtractionErrorDetail"][];
            methodBreakdown: {
                [key: string]: components["schemas"]["MethodHealthSummary"];
            };
            /** Format: int32 */
            commaExtractionsCount?: number;
            /** Format: int32 */
            weightReconciliationEventCount?: number;
            /** Format: double */
            weightReconciliationCommaRate?: number;
            /** Format: int32 */
            pass1CorrectionTotal?: number;
            /** Format: int32 */
            pass2CorrectionTotal?: number;
            /** Format: int32 */
            pass3CorrectionTotal?: number;
            /** Format: int32 */
            pass5CorrectionTotal?: number;
            /** Format: int32 */
            pass5DocumentCount?: number;
            /** Format: double */
            pass5DocumentRate?: number;
            /** Format: int32 */
            weightReconciliationWarnings?: number;
            timeSeries?: components["schemas"]["TimeSeriesDataPointOfExtractionHealthMetrics"][] | null;
        };
        ExtractionMetadata: {
            filename?: string | null;
            displayName?: string | null;
            teamId?: string | null;
            /** Format: uuid */
            transactionId?: string | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        ExtractionMethod: ExtractionMethod;
        ExtractionMethodOutput: {
            /** Format: int32 */
            cargoItemCount?: number;
            /** Format: int32 */
            ctuCount?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: double */
            avgPagesPerDocument?: number;
        };
        ExtractionModelConfigResponse: {
            /** Format: uuid */
            id?: string;
            codeName?: string | null;
            providerType?: components["schemas"]["ExtractionProviderType"];
            modelName?: string | null;
            baseUrl?: string | null;
            apiKey?: string | null;
            layoutAssistedExtraction?: boolean;
            requiresBackgroundExecution?: boolean;
            enabled?: boolean;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
            createdBy?: string | null;
            updatedBy?: string | null;
            updatedByName?: string | null;
        };
        ExtractionOutputMetrics: {
            /** Format: int32 */
            totalCargoItemsExtracted?: number;
            /** Format: int32 */
            totalCTUsExtracted?: number;
            byMethod: {
                [key: string]: components["schemas"]["ExtractionMethodOutput"];
            };
            timeSeries?: components["schemas"]["TimeSeriesDataPointOfExtractionOutputMetrics"][] | null;
        };
        ExtractionPromptConfigPatch: {
            decimalSeparator?: components["schemas"]["DecimalSeparator"];
        };
        ExtractionPromptConfigResponse: {
            decimalSeparator?: components["schemas"]["DecimalSeparator"];
        };
        /** @enum {string} */
        ExtractionProviderType: ExtractionProviderType;
        ExtractionResponse: {
            data?: components["schemas"]["ExtractedDocument"];
            metadata: components["schemas"]["ExtractionMetadata"];
            extractionMethod?: components["schemas"]["ExtractionMethod"];
            documentType?: components["schemas"]["DocumentType"];
            /** Format: uuid */
            jobId?: string | null;
            cargoBbox?: components["schemas"]["CargoBbox"];
            layoutDetection?: components["schemas"]["LayoutDetectionResult"];
            substanceValidation?: components["schemas"]["SubstanceVerificationResponse"];
            errorReport?: components["schemas"]["ErrorReport"];
            formData?: components["schemas"]["ValidationFormData"];
            originalMappedGoods?: components["schemas"]["FormDangerousGoodsItem"][] | null;
        };
        FeedbackSubmissionResponse: {
            message: string;
            /** Format: date-time */
            submittedAt?: string;
            reference?: string | null;
        };
        FieldChangeDetail: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            transactionId?: string;
            fieldPath: string;
            oldValue?: string | null;
            newValue?: string | null;
            changeKind?: components["schemas"]["CurationChangeKind"];
            cargoId?: string | null;
            ctuId?: string | null;
            itemLabel?: string | null;
            /** Format: int32 */
            pageNo?: number | null;
            /** Format: date-time */
            curatedAt?: string;
            curatedBy?: components["schemas"]["UserSummaryDto"];
        };
        FieldChangeDetailResponse: {
            fieldKey: string;
            changes: components["schemas"]["FieldChangeDetail"][];
            /** Format: int32 */
            total?: number;
            /** Format: int32 */
            page?: number;
            /** Format: int32 */
            pageSize?: number;
        };
        FieldChangeFrequency: {
            fieldKey: string;
            /** Format: int32 */
            changeCount?: number;
            /** Format: int32 */
            transactionCount?: number;
            /** Format: int32 */
            fillCount?: number;
            /** Format: int32 */
            correctionCount?: number;
            /** Format: int32 */
            clearCount?: number;
        };
        FieldComparisonRef: {
            validated?: string | null;
            normalisedValidated?: string | null;
            isRequired?: boolean;
            presenceOnly?: boolean;
        };
        FieldOverride: {
            severity?: components["schemas"]["IssueSeverity"];
            enabled?: boolean | null;
        };
        FieldValueChange: {
            oldValue?: string | null;
            newValue?: string | null;
            /** Format: int32 */
            count?: number;
        };
        FieldValueChangeResponse: {
            fieldKey: string;
            changes: components["schemas"]["FieldValueChange"][];
        };
        FlashpointInfo: {
            temperature?: components["schemas"]["FlashpointTemperature"];
            modifier?: string | null;
        };
        FlashpointInformation: {
            description?: string | null;
            /** Format: double */
            minimumTemperature?: number;
            /** Format: double */
            maximumTemperature?: number;
        };
        FlashpointTemperature: {
            /** Format: double */
            value?: number | null;
            unit?: string | null;
        };
        FormCarbonOfOrganicOriginDeclarationDetails: {
            dateOfPacking?: string | null;
            dateOfProduction?: string | null;
            temperatureOnDateOfPacking?: string | null;
        };
        FormCompatibilityCheckRequest: {
            substances?: components["schemas"]["SubstanceForValidation"][] | null;
            cargoTransportUnits?: components["schemas"]["CargoTransportUnitDto"][] | null;
            metadata?: components["schemas"]["ValidationMetadata"];
            checkKind?: components["schemas"]["CompatibilityCheckKind"];
        };
        FormCompatibilityCheckResponse: {
            request: components["schemas"]["HazcheckV3BetaValidationRequest"];
            check: components["schemas"]["CompatibilityCheckResponse"];
        };
        FormDangerousGoodsItem: {
            unNumber?: string | null;
            properShippingName?: string | null;
            hazardClass?: string | null;
            packingGroup?: string | null;
            technicalName?: string | null;
            subsidiaryHazards?: string[] | null;
            technicalOrChemicalName?: string | null;
            fireworkClassificationCode?: string | null;
            dsitCode?: string | null;
            t75EndOfHoldingTime?: string | null;
            controlTemperature?: components["schemas"]["FormTemperature"];
            emergencyTemperature?: components["schemas"]["FormTemperature"];
            radioactivityDetails?: components["schemas"]["FormRadioactivityDetails"];
            fumigationDetails?: components["schemas"]["FormFumigationDetails"];
            carbonOfOrganicOriginDeclarationDetails?: components["schemas"]["FormCarbonOfOrganicOriginDeclarationDetails"];
            substanceId?: string | null;
            quantity?: string | null;
            /** Format: double */
            netWeight?: number | null;
            /** Format: double */
            grossWeight?: number | null;
            /** Format: double */
            netExplosiveContent?: number | null;
            flashpoint?: components["schemas"]["FlashpointInfo"];
            declarationParameters?: components["schemas"]["FormDeclarationParameters"];
            emsNumber?: string | null;
            outerPackaging?: components["schemas"]["PackagingDetail"];
            innerPackaging?: components["schemas"]["PackagingDetail"];
            emergencyContactName?: string | null;
            emergencyContactPhone?: string | null;
            emergencyContact247?: boolean | null;
            additionalSegregationGroups?: string[] | null;
            /** Format: int32 */
            pageNo?: number | null;
            /** Format: int32 */
            sectionIdx?: number | null;
            cargoId: string;
            ctuId: string;
            dcm?: components["schemas"]["DcmCargoFields"];
            /** Format: double */
            capacity?: number | null;
            /** Format: double */
            actualDgWeight?: number | null;
            rawSourceFields?: {
                unNumber?: string;
                properShippingName?: string;
                technicalName?: string;
                hazardClass?: string;
                packingGroup?: string;
                subsidiaryRisk?: string;
                emsNumber?: string;
                substanceId?: string;
                netWeight?: string;
                grossWeight?: string;
                netExplosiveContent?: string;
                weight?: string;
                outerPackaging?: string;
                outerPackagingCount?: string;
                innerPackaging?: string;
                innerPackagingCount?: string;
                saidToContain?: string;
                flashpoint?: string;
                additionalSegregationGroups?: string;
                capacity?: string;
                actualDgWeight?: string;
                dsitCode?: string;
                fireworkClassificationCode?: string;
                t75EndOfHoldingTime?: string;
                dateOfPacking?: string;
                dateOfProduction?: string;
                carbonOfOrganicOriginTemperature?: string;
                controlTemperature?: string;
                emergencyTemperature?: string;
                isMarinePollutant?: string;
                isLimitedQuantity?: string;
                emergencyContactName?: string;
                emergencyContactPhone?: string;
                fumigantName?: string;
                fumigationDateTime?: string;
                fumigantDosage?: string;
                radionuclide?: string;
                descriptionOfMaterial?: string;
                radioactivity?: string;
                radioactiveCategory?: string;
                transportIndex?: string;
                criticalitySafetyIndex?: string;
            } | null;
        };
        FormDeclarationParameters: {
            isCoolant?: boolean;
            isConditioner?: boolean;
            isHot?: boolean;
            isMolten?: boolean;
            isStabilized?: boolean;
            isMarinePollutant?: boolean;
            isWaste?: boolean;
            isEmptyUncleaned?: boolean;
            isLimitedQuantity?: boolean;
            isExceptedQuantity?: boolean;
            isSalvagePackaging?: boolean;
            isSalvagePressureReceptacle?: boolean;
            isMixture?: boolean;
            isSolution?: boolean;
            isSample?: boolean;
            isFoodstuffs?: boolean;
            isStabilizedNotByTemperatureControl?: boolean | null;
            isReportableQuantity?: boolean | null;
            isPoisonInhalationHazard?: boolean | null;
            isWettedOrDesensitized?: boolean;
        };
        FormEmergencyContact: {
            name?: string | null;
            methods?: components["schemas"]["FormEmergencyContactMethod"][] | null;
            contract?: string | null;
            available247?: boolean | null;
        };
        FormEmergencyContactMethod: {
            number?: string | null;
            email?: string | null;
            description?: string | null;
        };
        FormFumigationDetails: {
            fumigantName?: string | null;
            fumigationDateTime?: string | null;
            fumigationDosageUsed?: string | null;
        };
        FormRadioactivityDetails: {
            radionuclide?: string | null;
            descriptionOfRadioactiveMaterial?: string | null;
            radioactivity?: string | null;
            radioactiveCategory?: string | null;
            /** Format: double */
            transportIndex?: number | null;
            /** Format: double */
            criticalitySafetyIndex?: number | null;
        };
        FormTemperature: {
            /** Format: double */
            value?: number | null;
            unit?: string | null;
        };
        HazcheckConfigDto: {
            clientId?: string | null;
            clientSecret?: string | null;
            enabled?: boolean;
        };
        HazcheckConfigResponse: {
            clientId?: string | null;
            clientSecret?: string | null;
            enabled?: boolean;
        };
        HazcheckV3BetaCarbonOfOrganicOriginDeclarationDetails: {
            dateOfProduction?: string | null;
            dateOfPacking?: string | null;
            temperatureOnDateOfPacking?: string | null;
        };
        HazcheckV3BetaCargoDescriptionRequest: {
            cargoReference?: string | null;
            parentReference?: string | null;
            substanceId?: string | null;
            technicalOrChemicalName?: string | null;
            additionalSubsidiaryHazards?: string[] | null;
            packingGroup?: components["schemas"]["HazcheckV3BetaCargoDescriptionRequestPackingGroup"];
            packagingReference?: string | null;
            weightDetails?: components["schemas"]["HazcheckV3BetaWeightDetails"];
            poisonInhalationHazardCode?: string | null;
            declarationParameters?: components["schemas"]["HazcheckV3BetaDeclarationParameters"];
            customCargoAttributes?: string[] | null;
            flashpoint?: components["schemas"]["HazcheckV3BetaFlashpoint"];
            permits?: components["schemas"]["HazcheckV3BetaPermitRequest"][] | null;
            replacementStowageCodes?: string[] | null;
            radioactivityDetails?: components["schemas"]["HazcheckV3BetaRadioactivityDetails"];
            packingMethod?: string | null;
            additionalSegregationGroups?: string[] | null;
            controlTemperature?: components["schemas"]["HazcheckV3BetaTemperature"];
            emergencyTemperature?: components["schemas"]["HazcheckV3BetaTemperature"];
            emergencyContactDetails?: components["schemas"]["HazcheckV3BetaEmergencyContactDetails"];
            fumigationDetails?: components["schemas"]["HazcheckV3BetaFumigationDetails"];
            additionalInformation?: string | null;
            substanceExcluded?: boolean;
            fireworkClassificationCode?: string | null;
            dsitCode?: string | null;
            cfr49ExNumber?: string | null;
            t75EndOfHoldingTime?: string | null;
            carbonOfOrganicOriginDeclarationDetails?: components["schemas"]["HazcheckV3BetaCarbonOfOrganicOriginDeclarationDetails"];
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaCargoDescriptionRequestPackingGroup: HazcheckV3BetaCargoDescriptionRequestPackingGroup;
        HazcheckV3BetaCargoTransportUnitRequest: {
            id?: string | null;
            bookingReference?: string | null;
            ctuReference?: string | null;
            hasAllDocuments?: boolean;
            unitType?: components["schemas"]["HazcheckV3BetaCargoTransportUnitRequestUnitType"];
            unitTypeAlias?: components["schemas"]["HazcheckV3BetaUnitTypeAlias"];
            containerInformation?: components["schemas"]["HazcheckV3BetaContainerInformation"];
            cargoDescriptions?: components["schemas"]["HazcheckV3BetaCargoDescriptionRequest"][] | null;
            packagingLookup?: components["schemas"]["HazcheckV3BetaPackaging"][] | null;
            dangerousGoodsNoteDetails?: components["schemas"]["HazcheckV3BetaDangerousGoodsNoteDetails"];
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaCargoTransportUnitRequestUnitType: HazcheckV3BetaCargoTransportUnitRequestUnitType;
        HazcheckV3BetaContainerInformation: {
            size?: string | null;
            type?: string | null;
            additionalInformation?: string | null;
            stowageLocation?: string | null;
            /** Format: double */
            grossWeight?: number | null;
            temperatureControl?: components["schemas"]["HazcheckV3BetaTemperatureControl"];
            /** Format: double */
            tareMassKg?: number | null;
            /** Format: double */
            volumeInM3?: number | null;
            nonDgContents?: components["schemas"]["HazcheckV3BetaNonDgContents"];
            deckLocation?: components["schemas"]["HazcheckV3BetaDeckLocation"][] | null;
        };
        HazcheckV3BetaDangerousGoodsNoteDetails: {
            templateName?: string | null;
            shipperAddress?: string | null;
            transportDocumentNumber?: string | null;
            shippersReference?: string | null;
            freightForwardersReference?: string | null;
            consignee?: string | null;
            carrier?: string | null;
            additionalHandlingInformation?: string | null;
            voyageNumber?: string | null;
            vessel?: string | null;
            sailingDate?: string | null;
            containerIdNumber?: string | null;
            containerSizeType?: string | null;
            tareMass?: string | null;
            totalGross?: string | null;
            sealNumbers?: string | null;
            cargoCubeOverrides?: components["schemas"]["HazcheckV3BetaDgnCargoCubeOverride"][] | null;
            nonDGCargo?: components["schemas"]["HazcheckV3BetaDgnNonDGCargoItem"][] | null;
            additionalCargoNotes?: string | null;
            packerCompanyName?: string | null;
            packerDeclarantName?: string | null;
            packerPlaceAndDate?: string | null;
            packerDeclarantSignature?: string | null;
            receivingOrganisationRemarks?: string | null;
            hauliersName?: string | null;
            hauliersVehicleRegNo?: string | null;
            hauliersSignatureAndDate?: string | null;
            hauliersDriversSignature?: string | null;
            shippersCompanyName?: string | null;
            shippersDeclarantName?: string | null;
            shippersPlaceAndDate?: string | null;
            shippersSignatureOfDeclarant?: string | null;
        };
        HazcheckV3BetaDeckLocation: {
            vesselId?: string | null;
            locationName?: string | null;
        };
        HazcheckV3BetaDeclarationParameters: {
            isStabilizedNotByTemperatureControl?: boolean | null;
            isCoolant?: boolean;
            isConditioner?: boolean;
            isHot?: boolean;
            isMolten?: boolean;
            isStabilized?: boolean;
            isMarinePollutant?: boolean;
            isWaste?: boolean;
            isEmptyUncleaned?: boolean;
            isLimitedQuantity?: boolean;
            isExceptedQuantity?: boolean;
            isSalvagePressureReceptacle?: boolean;
            isSalvagePackaging?: boolean;
            isMixture?: boolean;
            isSolution?: boolean;
            isSample?: boolean;
            isFoodstuffs?: boolean;
            isReportableQuantity?: boolean | null;
            isPoisonInhalationHazard?: boolean | null;
            isWettedOrDesensitized?: boolean;
        };
        HazcheckV3BetaDgnCargoCubeOverride: {
            cargoReference?: string | null;
            /** Format: double */
            cube?: number | null;
        };
        HazcheckV3BetaDgnNonDGCargoItem: {
            id?: string | null;
            details?: string | null;
            /** Format: double */
            grossMass?: number;
            /** Format: double */
            netMass?: number | null;
            /** Format: double */
            cube?: number | null;
        };
        HazcheckV3BetaEmergencyContactDetails: {
            emergencyContactName?: string | null;
            emergencyContactNumber?: string | null;
        };
        HazcheckV3BetaFlashpoint: {
            temperature?: components["schemas"]["HazcheckV3BetaTemperature"];
            cup?: components["schemas"]["HazcheckV3BetaFlashpointCup"];
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaFlashpointCup: HazcheckV3BetaFlashpointCup;
        HazcheckV3BetaFumigationDetails: {
            fumigantName?: string | null;
            fumigationDateTime?: string | null;
            fumigationDosageUsed?: string | null;
        };
        HazcheckV3BetaItineraryLegRequest: {
            id?: string | null;
            vesselId?: string | null;
            locations?: components["schemas"]["HazcheckV3BetaItineraryLocationRequest"][] | null;
            cargoOrPassenger?: components["schemas"]["HazcheckV3BetaItineraryLegRequestCargoOrPassenger"];
            mode?: components["schemas"]["HazcheckV3BetaItineraryLegRequestMode"];
            journeyLength?: components["schemas"]["HazcheckV3BetaItineraryLegRequestJourneyLength"];
            voyageReference?: string | null;
            voyageNumber?: string | null;
            carrierIdentifier?: string | null;
            carrierIdentificationCode?: string | null;
            carrierResponsibleAgencyCode?: string | null;
            operatorId?: string | null;
            operatorCode?: string | null;
            vesselCode?: string | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaItineraryLegRequestCargoOrPassenger: HazcheckV3BetaItineraryLegRequestCargoOrPassenger;
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaItineraryLegRequestJourneyLength: HazcheckV3BetaItineraryLegRequestJourneyLength;
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaItineraryLegRequestMode: HazcheckV3BetaItineraryLegRequestMode;
        HazcheckV3BetaItineraryLocationRequest: {
            id?: string | null;
            reference?: string | null;
            locationId?: string | null;
            stage?: components["schemas"]["HazcheckV3BetaItineraryLocationRequestStage"];
            dateOfArrival?: string | null;
            dateOfDeparture?: string | null;
            cutOffDate?: string | null;
            code?: string | null;
            terminalId?: string | null;
            berthId?: string | null;
            terminalCode?: string | null;
            berthCode?: string | null;
            isUNLocation?: boolean;
            sailingCallId?: string | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaItineraryLocationRequestStage: HazcheckV3BetaItineraryLocationRequestStage;
        HazcheckV3BetaItineraryRequest: {
            name?: string | null;
            sailingId?: string | null;
            legs?: components["schemas"]["HazcheckV3BetaItineraryLegRequest"][] | null;
        };
        HazcheckV3BetaMassData: {
            unit?: components["schemas"]["HazcheckV3BetaMassDataUnit"];
            /** Format: double */
            value?: number;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaMassDataUnit: HazcheckV3BetaMassDataUnit;
        HazcheckV3BetaNonDgContents: {
            animalOrVegetableOil?: boolean;
            foodStuffs?: boolean;
            ironOxides?: boolean;
            liquidOrganicSubstances?: boolean;
            odourAbsorbingCargo?: boolean;
            combustableMaterials?: boolean;
        };
        HazcheckV3BetaPackageDetails: {
            code?: string | null;
            /** Format: int32 */
            amount?: number | null;
            type?: components["schemas"]["HazcheckV3BetaPackageDetailsType"];
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaPackageDetailsType: HazcheckV3BetaPackageDetailsType;
        HazcheckV3BetaPackaging: {
            packageReference?: string | null;
            outerPackaging?: components["schemas"]["HazcheckV3BetaPackageDetails"];
            intermediatePackaging?: string | null;
            innerPackaging?: components["schemas"]["HazcheckV3BetaPackageDetails"];
            approvalReference?: string | null;
        };
        HazcheckV3BetaPermitRequest: {
            type?: string | null;
            value?: string | null;
        };
        HazcheckV3BetaRadioactivityDetails: {
            radionuclide?: string | null;
            radioactivity?: string | null;
            radioactiveCategory?: components["schemas"]["HazcheckV3BetaRadioactivityDetailsRadioactiveCategory"];
            /** Format: double */
            criticalitySafetyIndex?: number | null;
            /** Format: double */
            transportIndex?: number | null;
            descriptionOfRadioactiveMaterial?: string | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaRadioactivityDetailsRadioactiveCategory: HazcheckV3BetaRadioactivityDetailsRadioactiveCategory;
        HazcheckV3BetaTemperature: {
            /** Format: double */
            value?: number;
            unit?: components["schemas"]["HazcheckV3BetaTemperatureUnit"];
        };
        HazcheckV3BetaTemperatureControl: {
            controlTemperature?: components["schemas"]["HazcheckV3BetaTemperature"];
            isOperational?: boolean;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaTemperatureUnit: HazcheckV3BetaTemperatureUnit;
        HazcheckV3BetaUnitTypeAlias: {
            alias?: string | null;
            icon?: string | null;
        };
        HazcheckV3BetaValidationRequest: {
            reference?: string | null;
            voyageNumber?: string | null;
            nameOfValidation?: string | null;
            regulationSources?: string[] | null;
            cargoTransportUnits?: components["schemas"]["HazcheckV3BetaCargoTransportUnitRequest"][] | null;
            itinerary?: components["schemas"]["HazcheckV3BetaItineraryRequest"];
            bookingOperatorId?: string | null;
            bookingOperatorCode?: string | null;
            allowPackagingsValidation?: boolean | null;
            additionalInformation?: string | null;
            completed?: boolean;
        };
        HazcheckV3BetaVolumeData: {
            unit?: components["schemas"]["HazcheckV3BetaVolumeDataUnit"];
            /** Format: double */
            value?: number;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        HazcheckV3BetaVolumeDataUnit: HazcheckV3BetaVolumeDataUnit;
        HazcheckV3BetaWeightDetails: {
            capacity?: components["schemas"]["HazcheckV3BetaVolumeData"];
            netWeight?: components["schemas"]["HazcheckV3BetaMassData"];
            grossWeight?: components["schemas"]["HazcheckV3BetaMassData"];
            netExplosiveContent?: components["schemas"]["HazcheckV3BetaMassData"];
            actualDGWeight?: components["schemas"]["HazcheckV3BetaMassData"];
        };
        HazcheckValidationProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errors?: {
                [key: string]: string[];
            } | null;
            cargoIndices?: {
                [key: string]: number;
            } | null;
        } & {
            [key: string]: unknown;
        };
        HealthResponse: {
            status: string;
            version: string;
            /** Format: date-time */
            timestamp?: string;
            services: {
                [key: string]: components["schemas"]["ServiceHealth"];
            };
            upstreams?: components["schemas"]["HealthUpstreams"];
        };
        HealthUpstreams: {
            hazcheckValidate?: {
                [key: string]: string;
            } | null;
        };
        ImdgAdditionalRequirements: {
            requiresTechnicalName?: boolean;
            requiresTechnicalNameIfDeclaredMarinePollutant?: boolean;
            requiresMarinePollutantChemicalNameIfDeclaredMP?: boolean;
            requiresSelfReactiveDetails?: boolean;
            requiresFlashpoint?: boolean;
            allowsReplacementStowageCodes?: boolean;
            skipsPackagingDetails?: boolean;
            requiresNEC?: boolean;
            requiresStabilized?: boolean;
            requiresTemperatureControl?: boolean;
            requiresRadionuclideDetails?: boolean;
            requiresCriticalitySafetyIndex?: boolean;
            requiresFumigationDetails?: boolean;
            requiresFireworkClassificationReference?: boolean;
            requiresEmergengySchedule?: boolean;
            requiresEndOfHoldingTime?: boolean;
            requiresDSITCode?: boolean;
            requiresSubhazardChemicalNames?: boolean;
            requiresOuterPackaging?: boolean;
            requiresNetWeight?: boolean;
            requiresCapacity?: boolean;
            requiresNetWeightOrCapacity?: boolean;
            requiresCarbonOfOrganicOriginDeclarationDetails?: boolean;
            requiresActualDgWeight?: boolean;
        };
        ImdgSubstance: {
            substanceId?: string | null;
            unNumber?: string | null;
            properShippingName?: string | null;
            properShippingNameIncludingQDT?: string | null;
            qdt?: string | null;
            variantInformation?: components["schemas"]["VariantInformation"];
            class?: string[] | null;
            subsidiaryHazards?: string[] | null;
            packingGroup?: string | null;
            state?: string | null;
            limitedQuantity?: string | null;
            exceptedQuantity?: string | null;
            specialProvisions?: string[] | null;
            segregationCodes?: string[] | null;
            segregationGroups?: string[] | null;
            packingInstructions?: string[] | null;
            packingProvisions?: string[] | null;
            tankInstructions?: string[] | null;
            tankProvisions?: string[] | null;
            ibcInstructions?: string[] | null;
            ibcProvisions?: string[] | null;
            stowage?: components["schemas"]["StowageInfo"];
            emergencySchedules?: components["schemas"]["EmergencySchedules"];
            additionalRequirements?: components["schemas"]["ImdgAdditionalRequirements"];
            optionalDeclarationParameters?: components["schemas"]["OptionalDeclarationParameters"];
            propertiesAndObservations?: string | null;
            highConsequence?: string | null;
            isMarinePollutant?: boolean;
            isFoodstuffsByDefault?: boolean;
            isOrganicPeroxide?: boolean;
            availableSubHazards?: string[] | null;
            ctuPlacards?: components["schemas"]["Sign"][] | null;
            ctuMarks?: components["schemas"]["Sign"][] | null;
            packageLabels?: components["schemas"]["Sign"][] | null;
            packageMarks?: components["schemas"]["Sign"][] | null;
            segregationBar?: components["schemas"]["SegregationBar"];
            flashpointInformation?: components["schemas"]["FlashpointInformation"];
            availableSelfReactiveDetails?: components["schemas"]["TechnicalNameDetails"][] | null;
        };
        InnerPackaging: {
            code?: string | null;
            description?: string | null;
            /** Format: int32 */
            count?: number | null;
        };
        /** @enum {string} */
        IssueSeverity: IssueSeverity;
        JobCreatedResponse: {
            /** Format: uuid */
            jobId?: string;
            filename: string;
        };
        JobFilterRequest: {
            /** Format: int32 */
            page?: number;
            /** Format: int32 */
            pageSize?: number;
            cursor?: string | null;
            status?: components["schemas"]["DocumentJobStatus"];
            transactionStatus?: components["schemas"]["TransactionStatus"];
            filename?: string | null;
            error?: string | null;
            showOnlyOwn?: boolean;
            unvalidatedOnly?: boolean;
            hasFeedback?: boolean;
            validationId?: string | null;
            transactionIds?: string[] | null;
            assignedToId?: string | null;
            documentType?: components["schemas"]["DocumentType"];
            jobIds?: string[] | null;
            issueFilter?: string | null;
            /** Format: date-time */
            createdAfter?: string | null;
            /** Format: date-time */
            createdBefore?: string | null;
        };
        JobResponse: {
            /** Format: uuid */
            id?: string;
            teamId?: string | null;
            filename: string;
            displayName?: string | null;
            status?: components["schemas"]["DocumentJobStatus"];
            /** Format: uuid */
            transactionId?: string | null;
            errorMessage?: string | null;
            errorCode?: components["schemas"]["ProblemSlug"];
            errorCategory?: components["schemas"]["ExtractionErrorCategory"];
            /** Format: int32 */
            retryCount?: number;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            completedAt?: string | null;
            metadata?: unknown;
            errorReport?: components["schemas"]["ErrorReport"];
            /** Format: date-time */
            assignedAt?: string | null;
            createdBy?: components["schemas"]["UserSummaryDto"];
            assignedTo?: components["schemas"]["UserSummaryDto"];
            /** Format: int32 */
            processingTimeMs?: number | null;
            extractionMethod?: components["schemas"]["ExtractionMethod"];
            documentType?: components["schemas"]["DocumentType"];
            transactionStatus?: components["schemas"]["TransactionStatus"];
            modelProvider?: string | null;
            modelName?: string | null;
            /** Format: date-time */
            exportedAt?: string | null;
            validationId?: string | null;
            /** Format: date-time */
            feedbackReceivedAt?: string | null;
        };
        LayoutDetectionResult: {
            /** Format: int32 */
            pageCount?: number;
            pages?: components["schemas"]["PageDetections"][] | null;
            pageImageUrlTemplate?: string | null;
        };
        MergePreviewCargo: {
            unNumber?: string | null;
            properShippingName?: string | null;
            technicalOrChemicalName?: string | null;
            hazardClass?: string | null;
        };
        MergePreviewCtu: {
            ctuId?: string | null;
            ctuReference?: string | null;
            /** Format: int32 */
            incomingIndex?: number | null;
            unitType?: components["schemas"]["UnitType"];
            outcome?: components["schemas"]["MergePreviewOutcome"];
            wasRenamed?: boolean;
            replacedCtuReference?: string | null;
            /** Format: int32 */
            replacedCargoCount?: number | null;
            clashesWithCtuId?: string | null;
            cargo?: components["schemas"]["MergePreviewCargo"][] | null;
        };
        /** @enum {string} */
        MergePreviewOutcome: MergePreviewOutcome;
        MergePreviewRequest: {
            validationRequest: components["schemas"]["HazcheckV3BetaValidationRequest"];
            targetValidationId: string | null;
            replacements?: {
                [key: string]: string;
            } | null;
        };
        MergePreviewResponse: {
            target?: components["schemas"]["MergePreviewTarget"];
            cargoTransportUnits?: components["schemas"]["MergePreviewCtu"][] | null;
            /** Format: int32 */
            readonly added?: number;
            /** Format: int32 */
            readonly updated?: number;
            /** Format: int32 */
            readonly unchanged?: number;
            /** Format: int32 */
            readonly removed?: number;
        };
        MergePreviewTarget: {
            id?: string | null;
            reference?: string | null;
            name?: string | null;
            voyageNumber?: string | null;
            regulationSources?: string[] | null;
            /** Format: int32 */
            ctuCount?: number;
            /** Format: int32 */
            cargoCount?: number;
            regulationsDiffer?: boolean;
            regulationsConflict?: string | null;
        };
        MethodHealthSummary: {
            /** Format: int32 */
            totalExtractions?: number;
            /** Format: int32 */
            errorCount?: number;
            /** Format: double */
            errorRate?: number;
            /** Format: int32 */
            downgradeCount?: number;
            /** Format: int32 */
            failureCount?: number;
        };
        ModelUsageBreakdown: {
            model?: string | null;
            provider?: string | null;
            /** Format: int32 */
            count?: number;
            /** Format: int64 */
            totalTokens?: number;
            /** Format: double */
            totalCostUsd?: number;
            /** Format: double */
            avgProcessingMs?: number | null;
        };
        OptionalDeclarationParameters: {
            canBeDeclaredAsMarinePollutant?: boolean;
            canBeDeclaredLimitedQuantity?: boolean;
            canBeDeclaredExceptedQuantity?: boolean;
            canBeDeclaredSample?: boolean;
            canBeDeclaredMolten?: boolean;
            canBeDeclaredMixture?: boolean;
            canBeDeclaredStabilized?: boolean;
            canBeDeclaredCoolantOrConditioner?: boolean;
            canBeDeclaredWaste?: boolean;
            canBeDeclaredHot?: boolean;
            canBeDeclaredSolution?: boolean;
            canBeDeclaredEmptyUncleaned?: boolean;
            canBeDeclaredSalvage?: boolean;
            canBeDeclaredSalvagePressureReceptacle?: boolean;
            canBeDeclaredWithSubHazards?: boolean;
            canBeDeclaredWettedOrDesensitized?: boolean;
        };
        Packaging: {
            ref?: string | null;
            code?: string | null;
            /** Format: int32 */
            count?: number | null;
            description?: string | null;
            inner?: components["schemas"]["InnerPackaging"];
        };
        PackagingDetail: {
            code?: string | null;
            description?: string | null;
            /** Format: int32 */
            count?: number | null;
            type?: string | null;
        };
        PackagingExtractedData: {
            code?: string | null;
            description?: string | null;
            ref?: string | null;
        };
        PackagingHierarchyRequest: {
            substanceId?: string | null;
            unitType?: components["schemas"]["UnitType"];
            sailingMode?: components["schemas"]["SailingMode"];
            isLq?: boolean;
            isSample?: boolean;
            isEq?: boolean;
            packingMethod?: string | null;
            extractedOuter?: components["schemas"]["PackagingExtractedData"];
            extractedInner?: components["schemas"]["PackagingExtractedData"];
            documentType?: components["schemas"]["DocumentType"];
        };
        PackagingHierarchyResponse: {
            hierarchy?: components["schemas"]["PackingHierarchyNode"][] | null;
            resolution?: components["schemas"]["PackagingResolutionDto"];
        };
        PackagingMatchResult: {
            code?: string | null;
            description?: string | null;
            type?: string | null;
            isFreePack?: boolean | null;
            /** Format: double */
            maximumNetWeightKg?: number | null;
            /** Format: double */
            maximumGrossWeightKg?: number | null;
            /** Format: double */
            maximumCapacityL?: number | null;
            /** Format: double */
            maximumNECKg?: number | null;
            /** Format: double */
            score?: number;
            matchType?: string | null;
        };
        PackagingResolutionDto: {
            kind: components["schemas"]["PackagingResolutionKind"];
            outer: components["schemas"]["PackagingMatchResult"][];
            inner: components["schemas"]["PackagingMatchResult"][];
            /** Format: int32 */
            parsedOuterCount?: number | null;
            /** Format: int32 */
            parsedInnerCount?: number | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        PackagingResolutionKind: PackagingResolutionKind;
        PackagingVerificationResult: {
            requiresOuterPackaging?: boolean;
            outerCodeValid?: boolean | null;
            innerCodeValid?: boolean | null;
            suggestedOuter?: components["schemas"]["PackagingMatchResult"];
            suggestedInner?: components["schemas"]["PackagingMatchResult"];
            resolvedOuter?: components["schemas"]["ResolvedPackaging"];
            resolvedInner?: components["schemas"]["ResolvedPackaging"];
            /** Format: int32 */
            parsedOuterCount?: number | null;
            /** Format: int32 */
            parsedInnerCount?: number | null;
            errors?: {
                unNumber?: string;
                properShippingName?: string;
                technicalName?: string;
                hazardClass?: string;
                packingGroup?: string;
                subsidiaryRisk?: string;
                emsNumber?: string;
                substanceId?: string;
                netWeight?: string;
                grossWeight?: string;
                netExplosiveContent?: string;
                weight?: string;
                outerPackaging?: string;
                outerPackagingCount?: string;
                innerPackaging?: string;
                innerPackagingCount?: string;
                saidToContain?: string;
                flashpoint?: string;
                additionalSegregationGroups?: string;
                capacity?: string;
                actualDgWeight?: string;
                dsitCode?: string;
                fireworkClassificationCode?: string;
                t75EndOfHoldingTime?: string;
                dateOfPacking?: string;
                dateOfProduction?: string;
                carbonOfOrganicOriginTemperature?: string;
                controlTemperature?: string;
                emergencyTemperature?: string;
                isMarinePollutant?: string;
                isLimitedQuantity?: string;
                emergencyContactName?: string;
                emergencyContactPhone?: string;
                fumigantName?: string;
                fumigationDateTime?: string;
                fumigantDosage?: string;
                radionuclide?: string;
                descriptionOfMaterial?: string;
                radioactivity?: string;
                radioactiveCategory?: string;
                transportIndex?: string;
                criticalitySafetyIndex?: string;
            } | null;
        };
        PackingHierarchyNode: {
            type?: components["schemas"]["PackingHierarchyType"];
            description?: string | null;
            code?: string | null;
            isFreePack?: boolean | null;
            /** Format: double */
            maximumNetWeightKg?: number | null;
            /** Format: double */
            maximumGrossWeightKg?: number | null;
            /** Format: double */
            maximumCapacityL?: number | null;
            /** Format: double */
            maximumNECKg?: number | null;
            children?: components["schemas"]["PackingHierarchyNode"][] | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        PackingHierarchyType: PackingHierarchyType;
        PageDetections: {
            /** Format: int32 */
            pageNumber?: number;
            detections?: components["schemas"]["DetectedRegion"][] | null;
        };
        PageOfExtractionEventListItem: {
            items: components["schemas"]["ExtractionEventListItem"][] | null;
            /** Format: int32 */
            total?: number | null;
            nextCursor?: string | null;
        };
        PageOfJobResponse: {
            items: components["schemas"]["JobResponse"][] | null;
            /** Format: int32 */
            total?: number | null;
            nextCursor?: string | null;
        };
        PageOfTransactionResponse: {
            items: components["schemas"]["TransactionResponse"][] | null;
            /** Format: int32 */
            total?: number | null;
            nextCursor?: string | null;
        };
        PageOfWebhookDeliveryListItem: {
            items: components["schemas"]["WebhookDeliveryListItem"][] | null;
            /** Format: int32 */
            total?: number | null;
            nextCursor?: string | null;
        };
        Parties: {
            shipper?: components["schemas"]["Party"];
            consignee?: components["schemas"]["Party"];
            freightForwarder?: components["schemas"]["Party"];
            carrier?: components["schemas"]["Party"];
        };
        Party: {
            name?: string | null;
            address?: string | null;
            contact?: string | null;
        };
        ProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        /** @enum {string} */
        ProblemSlug: ProblemSlug;
        ProblemTypeMetadata: {
            code?: components["schemas"]["ProblemSlug"];
            /** Format: int32 */
            status?: number;
            title?: string | null;
            summary?: string | null;
            userMessage?: string | null;
            extensions?: string[] | null;
        };
        QueryParams: {
            un?: string | null;
            class?: string | null;
            packingGroup?: string | null;
            properShippingName?: string | null;
        };
        RankSubstancesRequest: {
            substanceIds?: string[] | null;
            properShippingName?: string | null;
            hazardClass?: string | null;
            packingGroup?: string | null;
            subsidiaryHazards?: string[] | null;
        };
        RankedSubstance: {
            substance?: components["schemas"]["ImdgSubstance"];
            variants?: components["schemas"]["SubstanceVariantGroup"][] | null;
            /** Format: double */
            matchScore?: number;
            breakdown?: components["schemas"]["SubstanceMatchBreakdown"];
            meetsAutoSelectBar?: boolean;
        };
        RankedSubstanceResponse: {
            substances?: components["schemas"]["RankedSubstance"][] | null;
        };
        ReferenceNumbers: {
            bookingReference?: string | null;
            transportDocumentNumber?: string | null;
            freightForwardersReference?: string | null;
            customsReference?: string | null;
            exportersReference?: string | null;
            shipperReference?: string | null;
            bookingNo?: string | null;
            documentReference?: string | null;
            additionalReferences?: string[] | null;
        };
        RegulationChoicesResponse: {
            default?: string[] | null;
            imdgAmendments?: string[] | null;
            addOns?: string[] | null;
            defaultFrom?: string | null;
        };
        RegulationSubstance: {
            substanceId?: string | null;
            unNumber?: string | null;
            regulation: string;
        } & components["schemas"]["Cfr49Substance"];
        RegulationsDto: {
            regulations: string[];
        };
        /** @enum {string} */
        RequirementAnswer: RequirementAnswer;
        ResolveValidationResponse: {
            /** Format: uuid */
            transactionId?: string;
        };
        ResolvedPackaging: {
            code?: string | null;
            description?: string | null;
            type?: string | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        SailingMode: SailingMode;
        SaveCuratedDataRequest: {
            curatedData?: components["schemas"]["CuratedArtifactResponse"];
        };
        SaveValidationResponse: {
            id: string;
            status: string;
            message?: string | null;
            validationUrl?: string | null;
            /** Format: date-time */
            timestamp?: string;
        };
        SeedTransactionResponse: {
            /** Format: uuid */
            transactionId?: string;
        };
        SeededTransactionSummary: {
            /** Format: uuid */
            id?: string;
            label?: string | null;
            /** Format: date-time */
            createdAt?: string;
        };
        SegregationBar: {
            data?: components["schemas"]["SegregationCell"][] | null;
        };
        SegregationCell: {
            conflictsWithOwnClass?: boolean;
            segregationType?: string | null;
            substanceClass?: string | null;
        };
        SegregationClash: {
            ctuReference: string;
            cargoReference: string;
            unNumber: string;
            clashingCtuReference: string;
            clashingCargoReference: string;
            clashingUnNumber: string;
            severity: string;
            customRule?: components["schemas"]["CustomRuleNote"];
            terms: components["schemas"]["SegregationTerm"][];
        };
        SegregationTerm: {
            degree: string;
            reasons: string[];
        };
        ServiceHealth: {
            status: string;
            message?: string | null;
        };
        Sign: {
            text?: string | null;
            image?: string | null;
        };
        StowageInfo: {
            stowageCategory?: string | null;
            stowageCodes?: string[] | null;
            handlingCodes?: string[] | null;
            cargoShipStowageMessage?: string | null;
            passengerShipStowageMessage?: string | null;
            cargoShipStowageDetails?: string[] | null;
            passengerShipStowageDetails?: string[] | null;
        };
        StowageSegregationComment: {
            comment: string;
        };
        SubmitValidationRequest: {
            validationRequest: components["schemas"]["HazcheckV3BetaValidationRequest"];
            checkKind?: components["schemas"]["CompatibilityCheckKind"];
            targetValidationId?: string | null;
            targetAction?: components["schemas"]["TargetSaveAction"];
            preserveReference?: boolean;
            removalAcknowledgement?: string | null;
            replacements?: {
                [key: string]: string;
            } | null;
        };
        SubstanceComparisonData: {
            cargoId?: string | null;
            substanceId?: string | null;
            unNumber?: components["schemas"]["FieldComparisonRef"];
            properShippingName?: components["schemas"]["FieldComparisonRef"];
            hazardClass?: components["schemas"]["FieldComparisonRef"];
            packingGroup?: components["schemas"]["FieldComparisonRef"];
            technicalName?: components["schemas"]["FieldComparisonRef"];
            flashpoint?: components["schemas"]["FieldComparisonRef"];
            segregationGroups?: components["schemas"]["FieldComparisonRef"];
            subsidiaryHazards?: components["schemas"]["FieldComparisonRef"];
            /** Format: double */
            flashpointMinCelsius?: number | null;
            /** Format: double */
            flashpointMaxCelsius?: number | null;
        };
        SubstanceForValidation: {
            unNumber?: string | null;
            properShippingName?: string | null;
            hazardClass?: string | null;
            packingGroup?: string | null;
            technicalName?: string | null;
            subsidiaryHazards?: string[] | null;
            technicalOrChemicalName?: string | null;
            fireworkClassificationCode?: string | null;
            dsitCode?: string | null;
            t75EndOfHoldingTime?: string | null;
            controlTemperature?: components["schemas"]["FormTemperature"];
            emergencyTemperature?: components["schemas"]["FormTemperature"];
            radioactivityDetails?: components["schemas"]["FormRadioactivityDetails"];
            fumigationDetails?: components["schemas"]["FormFumigationDetails"];
            carbonOfOrganicOriginDeclarationDetails?: components["schemas"]["FormCarbonOfOrganicOriginDeclarationDetails"];
            substanceId?: string | null;
            weights?: components["schemas"]["WeightDetails"];
            outerPackaging?: components["schemas"]["PackagingDetail"];
            innerPackaging?: components["schemas"]["PackagingDetail"];
            declarationParams?: components["schemas"]["DeclarationParams"];
            emergencyContact?: components["schemas"]["EmergencyContact"];
            flashpoint?: components["schemas"]["FlashpointInfo"];
            additionalSegregationGroups?: string[] | null;
            ctuId?: string | null;
            cargoId?: string | null;
        };
        SubstanceGroup: {
            /** Format: int32 */
            substanceCount?: number;
            substanceIds?: string[] | null;
            substances?: components["schemas"]["SubstanceSummary"][] | null;
            /** Format: int32 */
            unrefinedSubstanceCount?: number;
            unrefinedSubstanceIds?: string[] | null;
            finalFilter?: string | null;
            url?: string | null;
        };
        SubstanceItemRequest: {
            unNumber?: string | null;
            hazardClass?: string | null;
            packingGroup?: string | null;
            properShippingName?: string | null;
            cargoId?: string | null;
            extractedOuter?: components["schemas"]["PackagingExtractedData"];
            extractedInner?: components["schemas"]["PackagingExtractedData"];
            unitType?: components["schemas"]["UnitType"];
            subsidiaryHazards?: string[] | null;
        };
        SubstanceMatchBreakdown: {
            /** Format: double */
            psnScore?: number;
            /** Format: double */
            classScore?: number;
            /** Format: double */
            packingGroupScore?: number;
            /** Format: double */
            subsidiaryHazardScore?: number;
        };
        SubstanceSingleResponse: {
            substance?: components["schemas"]["ImdgSubstance"];
            variants?: components["schemas"]["SubstanceVariantGroup"][] | null;
        };
        SubstanceSummary: {
            substanceId?: string | null;
            unNumber?: string | null;
            prefix?: string | null;
            class?: string[] | null;
            properShippingName?: string | null;
            qdt?: string | null;
            properShippingNameIncludingQDT?: string | null;
            variantDescription?: string | null;
            packingGroup?: string | null;
            notesAndMessages?: string[] | null;
            labels?: string[] | null;
        };
        SubstanceVariant: {
            id?: string | null;
            description?: string | null;
        };
        SubstanceVariantGroup: {
            regulation?: string | null;
            descriptions: components["schemas"]["SubstanceVariant"][];
        };
        SubstanceVerificationMetrics: {
            /** Format: int32 */
            totalValidationRequests?: number;
            /** Format: int32 */
            totalSubstances?: number;
            /** Format: int32 */
            exactMatchCount?: number;
            /** Format: int32 */
            multipleMatchCount?: number;
            /** Format: int32 */
            noMatchCount?: number;
            /** Format: int32 */
            errorCount?: number;
            /** Format: int32 */
            autoSelectionCount?: number;
            /** Format: double */
            percentExactMatch?: number;
            /** Format: double */
            percentNoMatch?: number;
            /** Format: double */
            percentAutoSelected?: number;
            /** Format: double */
            avgProcessingTimeMs?: number | null;
            /** Format: double */
            totalProcessingTimeMs?: number | null;
            topNoMatchUnNumbers: components["schemas"]["UnNumberMatchSummary"][];
            topQueriedUnNumbers: components["schemas"]["UnNumberMatchSummary"][];
            timeSeries?: components["schemas"]["TimeSeriesDataPointOfSubstanceVerificationMetrics"][] | null;
        };
        SubstanceVerificationRequest: {
            substanceItems?: components["schemas"]["SubstanceItemRequest"][] | null;
            /** Format: uuid */
            transactionId?: string;
        };
        SubstanceVerificationResponse: {
            readonly success?: boolean;
            results?: components["schemas"]["SubstanceVerificationResult"][] | null;
            /** Format: int32 */
            readonly totalItems?: number;
            /** Format: int32 */
            readonly itemsWithExactMatch?: number;
            /** Format: int32 */
            readonly itemsWithMultipleMatches?: number;
            /** Format: int32 */
            readonly itemsWithNoMatch?: number;
            /** Format: int32 */
            readonly itemsWithErrors?: number;
            /** Format: int32 */
            readonly itemsWithAutoSelection?: number;
            /** Format: double */
            processingTimeSeconds?: number;
            regulations?: string[] | null;
            enrichedSubstances?: {
                [key: string]: components["schemas"]["ImdgSubstance"];
            } | null;
            pairedSubstances?: {
                [key: string]: {
                    [key: string]: components["schemas"]["RegulationSubstance"];
                };
            } | null;
            addOnAnswers?: {
                [key: string]: {
                    [key: string]: {
                        [key: string]: components["schemas"]["RequirementAnswer"];
                    };
                };
            } | null;
            substanceGroups?: {
                [key: string]: components["schemas"]["SubstanceGroup"];
            } | null;
            comparisons?: {
                [key: string]: components["schemas"]["SubstanceComparisonData"];
            } | null;
        };
        SubstanceVerificationResult: {
            unNumber?: string | null;
            queryParams?: components["schemas"]["QueryParams"];
            finalFilter?: string | null;
            url?: string | null;
            /** Format: int32 */
            substanceCount?: number;
            substanceIds?: string[] | null;
            substances?: components["schemas"]["SubstanceSummary"][] | null;
            /** Format: int32 */
            unrefinedSubstanceCount?: number;
            unrefinedSubstanceIds?: string[] | null;
            validationStatus?: components["schemas"]["SubstanceVerificationStatus"];
            autoSelectedSubstanceId?: string | null;
            selectedSubstanceId?: string | null;
            cargoId?: string | null;
            substanceGroupKey?: string | null;
            error?: string | null;
            errorCode?: components["schemas"]["ProblemSlug"];
            packagingValidation?: components["schemas"]["PackagingVerificationResult"];
        };
        /** @enum {string} */
        SubstanceVerificationStatus: SubstanceVerificationStatus;
        SupportReportRequest: {
            message: string;
            traceId?: string | null;
            pageUrl?: string | null;
            requestUrl?: string | null;
            requestMethod?: string | null;
            /** Format: int32 */
            status?: number | null;
            userAgent?: string | null;
            stack?: string | null;
            componentStack?: string | null;
            transactionId?: string | null;
            transactionUrl?: string | null;
        };
        SupportReportResponse: {
            success?: boolean;
            reference?: string | null;
        };
        /** @enum {string} */
        TargetSaveAction: TargetSaveAction;
        TeamMemberResponse: {
            id: string;
            name?: string | null;
            username: string;
            email: string;
        };
        TeamModelAssignmentResponse: {
            teamId: string | null;
            /** Format: uuid */
            primaryModelConfigId?: string | null;
            /** Format: uuid */
            secondaryModelConfigId?: string | null;
            allowFailover?: boolean;
            /** Format: int32 */
            failoverAfterAttempts?: number;
        };
        TeamSettingsResponse: {
            id?: string | null;
            teamId?: string | null;
            hazcheckConfig?: components["schemas"]["HazcheckConfigResponse"];
            webhookConfig?: components["schemas"]["WebhookConfigResponse"];
            defaultExtractionMethod?: components["schemas"]["ExtractionMethod"];
            transactionNameSource?: components["schemas"]["TransactionNameSource"];
            exportDestination?: components["schemas"]["ExportDestination"];
            allowGenericPackagingFallback?: boolean;
            /** Format: uuid */
            primaryModelConfigId?: string | null;
            /** Format: uuid */
            secondaryModelConfigId?: string | null;
            allowFailover?: boolean;
            /** Format: int32 */
            failoverAfterAttempts?: number;
            workflowFormConfig?: components["schemas"]["WorkflowFormConfigDto"];
            extractionPromptDefaults?: components["schemas"]["ExtractionPromptConfigResponse"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
            createdBy?: string | null;
            updatedBy?: string | null;
        };
        TechnicalNameDetails: {
            unNumberVariant?: string | null;
            unNumber?: string | null;
            name?: string | null;
            inPacks?: boolean;
            inTanks?: boolean;
            inIBCS?: boolean;
            technicalName?: string | null;
            concentration?: string | null;
            diluentTypeA?: string | null;
            diluentTypeB?: string | null;
            inertSolid?: string | null;
            percentageWater?: string | null;
            packingMethod?: string | null;
            controlTemperature?: string | null;
            emergencyTemperature?: string | null;
            subRisks?: string | null;
            remarks?: string | null;
            maxQuantity?: string | null;
            substanceId?: string | null;
            emergencySchedules?: components["schemas"]["EmergencySchedules"];
        };
        TimeSeriesDataPointOfCurationMetricsSummary: {
            /** Format: date-time */
            periodStart?: string;
            /** Format: date-time */
            periodEnd?: string;
            metrics?: components["schemas"]["CurationMetricsSummary"];
        };
        TimeSeriesDataPointOfExtractionHealthMetrics: {
            /** Format: date-time */
            periodStart?: string;
            /** Format: date-time */
            periodEnd?: string;
            metrics?: components["schemas"]["ExtractionHealthMetrics"];
        };
        TimeSeriesDataPointOfExtractionOutputMetrics: {
            /** Format: date-time */
            periodStart?: string;
            /** Format: date-time */
            periodEnd?: string;
            metrics?: components["schemas"]["ExtractionOutputMetrics"];
        };
        TimeSeriesDataPointOfSubstanceVerificationMetrics: {
            /** Format: date-time */
            periodStart?: string;
            /** Format: date-time */
            periodEnd?: string;
            metrics?: components["schemas"]["SubstanceVerificationMetrics"];
        };
        TimeSeriesDataPointOfUsageMetricsSummary: {
            /** Format: date-time */
            periodStart?: string;
            /** Format: date-time */
            periodEnd?: string;
            metrics?: components["schemas"]["UsageMetricsSummary"];
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        TimeSeriesGrouping: TimeSeriesGrouping;
        TransactionJobSummary: {
            /** Format: uuid */
            id?: string;
            assignedTo?: components["schemas"]["UserSummaryDto"];
        };
        TransactionMetadata: {
            extractionMethod?: components["schemas"]["ExtractionMethod"];
            modelProvider?: string | null;
            modelName?: string | null;
            /** Format: double */
            fileSizeMb?: number | null;
            /** Format: int32 */
            promptTokenCount?: number | null;
            /** Format: int32 */
            candidatesTokenCount?: number | null;
            /** Format: int32 */
            totalTokenCount?: number | null;
            /** Format: double */
            estimatedCostUsd?: number | null;
            /** Format: date-time */
            extractedAt?: string;
            /** Format: int32 */
            cargoItemCount?: number | null;
            /** Format: int32 */
            ctuCount?: number | null;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        TransactionNameSource: TransactionNameSource;
        TransactionResponse: {
            /** Format: uuid */
            id?: string;
            userId: string;
            teamId?: string | null;
            filename: string;
            displayName?: string | null;
            status?: components["schemas"]["TransactionStatus"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: date-time */
            completedAt?: string | null;
            metadata?: components["schemas"]["TransactionMetadata"];
            documentType?: components["schemas"]["DocumentType"];
            curatedById?: string | null;
            /** Format: date-time */
            exportedAt?: string | null;
            /** Format: int32 */
            rerunCount?: number;
            warnings?: string[] | null;
        };
        TransactionSavedData: {
            /** Format: int32 */
            readonly version?: number;
            /** Format: uuid */
            transactionId: string;
            hazcheckValidationId?: string | null;
            status?: string | null;
            validationUrl?: string | null;
        };
        /** @enum {string} */
        TransactionStatus: TransactionStatus;
        TransactionWithArtifactsResponse: {
            transaction?: components["schemas"]["TransactionResponse"];
            artifacts?: components["schemas"]["ArtifactInfo"][] | null;
            curated?: components["schemas"]["CuratedArtifactResponse"];
            extracted?: components["schemas"]["ExtractedDocument"];
            layoutDetection?: components["schemas"]["CargoSectionResult"];
            substanceValidation?: components["schemas"]["SubstanceVerificationResponse"];
            errorReport?: components["schemas"]["ErrorReport"];
            formData?: components["schemas"]["ValidationFormData"];
            originalMappedGoods?: components["schemas"]["FormDangerousGoodsItem"][] | null;
            job?: components["schemas"]["TransactionJobSummary"];
            cargoDevMeta?: {
                [key: string]: components["schemas"]["CargoDevMeta"];
            } | null;
            savedValidation?: components["schemas"]["SaveValidationResponse"];
        };
        Transport: {
            vesselName?: string | null;
            voyageNumber?: string | null;
            portOfLoading?: string | null;
            portOfDischarge?: string | null;
            placeOfDelivery?: string | null;
        };
        TriggerErrorRequest: {
            slug?: components["schemas"]["ProblemSlug"];
        };
        UnNumberMatchSummary: {
            unNumber: string;
            /** Format: int32 */
            totalLookups?: number;
            /** Format: int32 */
            exactMatches?: number;
            /** Format: int32 */
            multipleMatches?: number;
            /** Format: int32 */
            noMatches?: number;
            /** Format: int32 */
            errors?: number;
            /** Format: double */
            percentExactMatch?: number;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        UnitType: UnitType;
        UpdateExtractionModelConfigRequest: {
            codeName?: string | null;
            providerType?: components["schemas"]["ExtractionProviderType"];
            modelName?: string | null;
            baseUrl?: string | null;
            apiKey?: string | null;
            layoutAssistedExtraction?: boolean | null;
            requiresBackgroundExecution?: boolean | null;
            enabled?: boolean | null;
        };
        UpdateTeamModelSelectionRequest: {
            /** Format: uuid */
            primaryModelConfigId?: string | null;
            /** Format: uuid */
            secondaryModelConfigId?: string | null;
            allowFailover?: boolean | null;
            /** Format: int32 */
            failoverAfterAttempts?: number | null;
        };
        UpdateTeamSettingsRequest: {
            hazcheckConfig?: components["schemas"]["HazcheckConfigDto"];
            webhookConfig?: components["schemas"]["WebhookConfigDto"];
            defaultExtractionMethod?: components["schemas"]["ExtractionMethod"];
            transactionNameSource?: components["schemas"]["TransactionNameSource"];
            exportDestination?: components["schemas"]["ExportDestination"];
            allowGenericPackagingFallback?: boolean | null;
            allowFailover?: boolean | null;
            /** Format: int32 */
            failoverAfterAttempts?: number | null;
            workflowFormConfig?: components["schemas"]["WorkflowFormConfigDto"];
            extractionPromptDefaults?: components["schemas"]["ExtractionPromptConfigPatch"];
        };
        UsageMetricsSummary: {
            /** Format: int32 */
            totalExtractions?: number;
            /** Format: int32 */
            successfulExtractions?: number;
            /** Format: int32 */
            failedExtractions?: number;
            /** Format: int32 */
            retriedExtractions?: number;
            /** Format: int64 */
            totalProcessingMs?: number;
            /** Format: double */
            avgProcessingMs?: number;
            /** Format: double */
            p50ProcessingMs?: number | null;
            /** Format: double */
            p90ProcessingMs?: number | null;
            /** Format: double */
            p99ProcessingMs?: number | null;
            /** Format: int32 */
            totalTokensUsed?: number;
            /** Format: double */
            avgTokensPerExtraction?: number;
            /** Format: double */
            totalEstimatedCostUsd?: number;
            /** Format: double */
            avgCostPerExtraction?: number;
            /** Format: int32 */
            totalPagesProcessed?: number;
            /** Format: double */
            avgPagesPerExtraction?: number;
            /** Format: int32 */
            maxPagesInDocument?: number | null;
            /** Format: int32 */
            minPagesInDocument?: number | null;
            byExtractionMethod: {
                [key: string]: number;
            };
            avgProcessingMsByMethod: {
                [key: string]: number;
            };
            models: components["schemas"]["ModelUsageBreakdown"][];
            timeSeries?: components["schemas"]["TimeSeriesDataPointOfUsageMetricsSummary"][] | null;
        };
        UserProfileResponse: {
            id: string;
            username: string;
            email: string;
            name?: string | null;
            teamId?: string | null;
            teamName?: string | null;
            roles: string[];
            features: string[];
            documentExtractionTypes: string[];
        };
        UserSummaryDto: {
            id: string;
            name?: string | null;
        };
        ValidationCompletedData: {
            /** Format: int32 */
            readonly version?: number;
            /** Format: uuid */
            transactionId: string;
            overallStatus?: string | null;
            /** Format: int32 */
            totalSubstances?: number;
            /** Format: int32 */
            compatibleSubstances?: number;
            /** Format: int32 */
            incompatibleSubstances?: number;
            compatibilityResponse?: components["schemas"]["CompatibilityCheckResponse"];
        };
        ValidationFormData: {
            datasetName?: string | null;
            description?: string | null;
            tags?: string | null;
            documentType?: components["schemas"]["DocumentType"];
            bookingNumber?: string | null;
            transportDocumentNumber?: string | null;
            freightForwarderReference?: string | null;
            customsReference?: string | null;
            exportersReference?: string | null;
            shipperReference?: string | null;
            documentReference?: string | null;
            shipper?: components["schemas"]["Party"];
            consignee?: components["schemas"]["Party"];
            freightForwarder?: components["schemas"]["Party"];
            carrier?: components["schemas"]["Party"];
            vesselName?: string | null;
            voyageNumber?: string | null;
            portOfLoading?: string | null;
            portOfDischarge?: string | null;
            placeOfDelivery?: string | null;
            dangerousGoods: components["schemas"]["FormDangerousGoodsItem"][];
            cargoTransportUnits: components["schemas"]["CargoTransportUnitDto"][];
            specialInstructions?: string | null;
            dgd?: components["schemas"]["DgdFormFields"];
            dcm?: components["schemas"]["DcmFormFields"];
        };
        ValidationMessage: {
            severity: string;
            regulation: string;
            regulationResult: string;
            resultSource: string;
            message: string;
            cargoIds?: string[] | null;
            customRule?: components["schemas"]["CustomRuleNote"];
            readonly effectiveSeverity: string;
        };
        ValidationMetadata: {
            reference?: string | null;
            name?: string | null;
            emergencyContacts?: components["schemas"]["FormEmergencyContact"][] | null;
        };
        ValidationProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errors?: {
                [key: string]: string[];
            } | null;
        } & {
            [key: string]: unknown;
        };
        ValidationRequestResponse: {
            validationRequest: components["schemas"]["HazcheckV3BetaValidationRequest"];
            /** Format: int32 */
            substanceCount?: number;
            /** Format: int32 */
            cargoUnitsCount?: number;
        };
        ValidationSourceResponse: {
            /** Format: uuid */
            transactionId?: string;
            transactionName?: string | null;
        };
        ValidationSourcesResponse: {
            id?: string | null;
            sources?: components["schemas"]["ValidationSourceResponse"][] | null;
        };
        ValidationSummaryResponse: {
            id?: string | null;
            reference?: string | null;
            name?: string | null;
        };
        VariantInformation: {
            suffix?: string | null;
            cvl?: string | null;
            description?: string | null;
        };
        /** @enum {string} */
        WarningKey: WarningKey;
        WarningSignage: {
            image: string;
            message: string;
        };
        /**
         * Format: int32
         * @enum {integer}
         */
        WebhookAuthType: WebhookAuthType;
        WebhookConfigDto: {
            url?: string | null;
            enabled?: boolean;
            events?: components["schemas"]["WebhookEvent"][] | null;
            authType?: components["schemas"]["WebhookAuthType"];
            bearerToken?: string | null;
            oAuthTokenUrl?: string | null;
            oAuthClientId?: string | null;
            oAuthClientSecret?: string | null;
            signingSecret?: string | null;
            retryEnabled?: boolean;
            /** Format: int32 */
            maxRetries?: number;
        };
        WebhookConfigResponse: {
            url?: string | null;
            enabled?: boolean;
            events?: components["schemas"]["WebhookEvent"][] | null;
            authType?: components["schemas"]["WebhookAuthType"];
            oAuthTokenUrl?: string | null;
            oAuthClientId?: string | null;
            oAuthClientSecret?: string | null;
            bearerToken?: string | null;
            signingSecret?: string | null;
            retryEnabled?: boolean;
            /** Format: int32 */
            maxRetries?: number;
        };
        WebhookDeliveryAttemptItem: {
            /** Format: int32 */
            attemptNumber: number;
            succeeded: boolean;
            /** Format: int32 */
            statusCode?: number | null;
            responseBody?: string | null;
            /** Format: double */
            deliveryTimeMs?: number | null;
            problem?: components["schemas"]["WebhookDeliveryProblem"];
            /** Format: date-time */
            completedAt: string;
        };
        WebhookDeliveryDetail: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            transactionId?: string | null;
            eventType: components["schemas"]["WebhookEvent"];
            status: components["schemas"]["WebhookDeliveryStatus"];
            /** Format: int32 */
            statusCode?: number | null;
            problem?: components["schemas"]["WebhookDeliveryProblem"];
            /** Format: double */
            deliveryTimeMs?: number | null;
            /** Format: int32 */
            attemptCount: number;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            deliveredAt?: string | null;
            /** Format: int32 */
            maxRetries: number;
            responseBody?: string | null;
            payloadJson?: string | null;
            /** Format: date-time */
            nextRetryAt?: string | null;
            attempts?: components["schemas"]["WebhookDeliveryAttemptItem"][] | null;
        };
        WebhookDeliveryListItem: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            transactionId?: string | null;
            eventType: components["schemas"]["WebhookEvent"];
            status: components["schemas"]["WebhookDeliveryStatus"];
            /** Format: int32 */
            statusCode?: number | null;
            problem?: components["schemas"]["WebhookDeliveryProblem"];
            /** Format: double */
            deliveryTimeMs?: number | null;
            /** Format: int32 */
            attemptCount: number;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            deliveredAt?: string | null;
        };
        WebhookDeliveryProblem: {
            type: string | null;
            title: string | null;
            /** Format: int32 */
            status: number;
            detail?: string | null;
            helpUrl?: string | null;
            /** Format: uuid */
            deliveryId: string;
            /** Format: int32 */
            customerStatusCode?: number | null;
            originatingTraceId?: string | null;
        };
        /** @enum {string} */
        WebhookDeliveryStatus: WebhookDeliveryStatus;
        /** @enum {string} */
        WebhookEvent: WebhookEvent;
        WebhookPayload: {
            /** Format: uuid */
            deliveryId: string;
            event: string | null;
            /** Format: int64 */
            timestamp: number;
            teamId: string | null;
            data: unknown;
            test?: boolean | null;
        };
        WebhookTestRequest: {
            eventType?: components["schemas"]["WebhookEvent"];
            testData?: {
                [key: string]: unknown;
            } | null;
        };
        WebhookTestResponse: {
            success?: boolean;
            /** Format: int32 */
            statusCode?: number | null;
            responseBody?: string | null;
            error?: string | null;
            errorCode?: string | null;
            /** Format: double */
            deliveryTimeMs?: number | null;
        };
        WeightDetails: {
            netWeight?: components["schemas"]["WeightValue"];
            grossWeight?: components["schemas"]["WeightValue"];
            capacity?: components["schemas"]["WeightValue"];
            netExplosiveContent?: components["schemas"]["WeightValue"];
            actualDgWeight?: components["schemas"]["WeightValue"];
        };
        WeightValue: {
            /** Format: double */
            value?: number | null;
            unit?: string | null;
        };
        WorkflowFormConfigDto: {
            hiddenSections?: string[] | null;
            hiddenFields?: string[] | null;
            disabledWarnings?: components["schemas"]["WarningKey"][] | null;
            dgFieldOverrides?: {
                [key: string]: components["schemas"]["FieldOverride"];
            } | null;
            ctuFieldOverrides?: {
                [key: string]: components["schemas"]["FieldOverride"];
            } | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export enum ArtifactName {
    Extracted = 0,
    Curated = 1,
    OriginalPdf = 2,
    LayoutExtracted = 3,
    MergedResult = 4,
    FailedExtraction = 5,
    SubstanceValidation = 6,
    FormData = 7,
    SavedValidation = 8,
    DcmRawText = 9,
    RawExtraction = 10
}
export enum CargoFieldName {
    UnNumber = "unNumber",
    ProperShippingName = "properShippingName",
    TechnicalName = "technicalName",
    HazardClass = "hazardClass",
    PackingGroup = "packingGroup",
    SubsidiaryRisk = "subsidiaryRisk",
    EmsNumber = "emsNumber",
    SubstanceId = "substanceId",
    NetWeight = "netWeight",
    GrossWeight = "grossWeight",
    NetExplosiveContent = "netExplosiveContent",
    Weight = "weight",
    OuterPackaging = "outerPackaging",
    OuterPackagingCount = "outerPackagingCount",
    InnerPackaging = "innerPackaging",
    InnerPackagingCount = "innerPackagingCount",
    SaidToContain = "saidToContain",
    Flashpoint = "flashpoint",
    AdditionalSegregationGroups = "additionalSegregationGroups",
    Capacity = "capacity",
    ActualDgWeight = "actualDgWeight",
    DsitCode = "dsitCode",
    FireworkClassificationCode = "fireworkClassificationCode",
    T75EndOfHoldingTime = "t75EndOfHoldingTime",
    DateOfPacking = "dateOfPacking",
    DateOfProduction = "dateOfProduction",
    CarbonOfOrganicOriginTemperature = "carbonOfOrganicOriginTemperature",
    ControlTemperature = "controlTemperature",
    EmergencyTemperature = "emergencyTemperature",
    IsMarinePollutant = "isMarinePollutant",
    IsLimitedQuantity = "isLimitedQuantity",
    EmergencyContactName = "emergencyContactName",
    EmergencyContactPhone = "emergencyContactPhone",
    FumigantName = "fumigantName",
    FumigationDateTime = "fumigationDateTime",
    FumigantDosage = "fumigantDosage",
    Radionuclide = "radionuclide",
    DescriptionOfMaterial = "descriptionOfMaterial",
    Radioactivity = "radioactivity",
    RadioactiveCategory = "radioactiveCategory",
    TransportIndex = "transportIndex",
    CriticalitySafetyIndex = "criticalitySafetyIndex"
}
export enum Cfr49SubstanceRegulation {
    CFR49 = "CFR49"
}
export enum CompatibilityCheckKind {
    Feasibility = "feasibility",
    Final = "final"
}
export enum CtuFieldName {
    ContainerNumber = "containerNumber",
    IsoCode = "isoCode",
    Size = "size",
    StowagePosition = "stowagePosition"
}
export enum CuratedCargoTransportUnitUnitType {
    openUnit = "openUnit",
    closedUnit = "closedUnit",
    tankUnit = "tankUnit",
    reefer = "reefer",
    heated = "heated",
    bulkOpen = "bulkOpen",
    bulkClosed = "bulkClosed"
}
export enum CurationChangeKind {
    Fill = "fill",
    Correction = "correction",
    Clear = "clear"
}
export enum CustomRuleKind {
    Restriction = "restriction",
    Exemption = "exemption"
}
export enum DangerousCargoManifestDocumentType {
    Value1 = "1"
}
export enum DangerousGoodsDocumentDocumentType {
    Value0 = "0"
}
export enum DecimalSeparator {
    Period = "period",
    Comma = "comma"
}
export enum DocumentJobStatus {
    Pending = "pending",
    Processing = "processing",
    Completed = "completed",
    Curated = "curated",
    Failed = "failed",
    Cancelled = "cancelled"
}
export enum DocumentType {
    Dgd = "dgd",
    Dcm = "dcm"
}
export enum ExportDestination {
    HazcheckValidate = "hazcheckValidate",
    Webhook = "webhook"
}
export enum ExtractionErrorCategory {
    Unknown = "Unknown",
    ServiceBusy = "ServiceBusy",
    Timeout = "Timeout",
    DgdGeminiError = "GeminiError",
    DgdParseFailure = "ParseFailure",
    DgdPdfUnreadable = "PdfUnreadable",
    DgdOutputTruncated = "OutputTruncated",
    DgdZeroCargo = "NoCargo",
    DgdPdfLowResolution = "LowResolution",
    DcmColumnHeaderNotFound = "DcmColumnHeaderNotFound",
    DcmParseFailure = "DcmParseFailure"
}
export enum ExtractionMethod {
    Single = 0,
    Merged = 1,
    Parallel = 2,
    LayoutOnly = 3
}
export enum ExtractionProviderType {
    Gemini = "gemini",
    OpenAi = "openAi",
    Qwen = "qwen"
}
export enum HazcheckV3BetaCargoDescriptionRequestPackingGroup {
    Empty = 0,
    I = 1,
    II = 2,
    III = 3
}
export enum HazcheckV3BetaCargoTransportUnitRequestUnitType {
    OpenUnit = 0,
    ClosedUnit = 1,
    TankUnit = 2,
    Reefer = 3,
    Heated = 4,
    BulkOpen = 5,
    BulkClosed = 6
}
export enum HazcheckV3BetaFlashpointCup {
    OpenCup = 0,
    ClosedCup = 1
}
export enum HazcheckV3BetaItineraryLegRequestCargoOrPassenger {
    Cargo = 0,
    Passenger = 1
}
export enum HazcheckV3BetaItineraryLegRequestJourneyLength {
    Unknown = 0,
    Short = 1,
    Long = 2
}
export enum HazcheckV3BetaItineraryLegRequestMode {
    Sea = 0,
    Road = 1,
    Rail = 2,
    Air = 3
}
export enum HazcheckV3BetaItineraryLocationRequestStage {
    Origin = 0,
    Load = 1,
    Transit = 2,
    Tranship = 3,
    Unload = 4,
    Destination = 5,
    Receipt = 6
}
export enum HazcheckV3BetaMassDataUnit {
    Kg = 0,
    G = 1
}
export enum HazcheckV3BetaPackageDetailsType {
    Single = 0,
    Composite = 1,
    Outer = 2,
    Intermediate = 3,
    Inner = 4,
    Generic = 5,
    Tank = 6,
    LargeOuter = 7,
    LargeInner = 8,
    IntermediateBulkContainer = 9,
    Bulk = 10,
    InnerNotSpecified = 11,
    LargeInnerNotSpecified = 12,
    OtherApprovedPackaging = 13
}
export enum HazcheckV3BetaRadioactivityDetailsRadioactiveCategory {
    I = 0,
    II = 1,
    III = 2
}
export enum HazcheckV3BetaTemperatureUnit {
    Celsius = 0,
    Fahrenheit = 1
}
export enum HazcheckV3BetaVolumeDataUnit {
    L = 0,
    Ml = 1
}
export enum IssueSeverity {
    Error = "error",
    Warning = "warning",
    Info = "info"
}
export enum MergePreviewOutcome {
    Unchanged = "unchanged",
    Added = "added",
    UpdatedByRecordedSource = "updatedByRecordedSource",
    UpdatedByContainerNumber = "updatedByContainerNumber",
    UpdatedByUserChoice = "updatedByUserChoice",
    Removed = "removed"
}
export enum PackagingResolutionKind {
    Resolved = 0,
    NeedsUserChoice = 1,
    NoMatch = 2
}
export enum PackingHierarchyType {
    Single = 0,
    Composite = 1,
    Group = 2,
    Outer = 3,
    Intermediate = 4,
    Inner = 5,
    Message = 6,
    Generic = 7,
    Tank = 8,
    LargeOuter = 9,
    LargeInner = 10,
    IntermediateBulkContainer = 11,
    Bulk = 12,
    InnerNotSpecified = 13,
    InnerSpecified = 14,
    LargeInnerNotSpecified = 15,
    OtherApprovedPackaging = 16
}
export enum ProblemSlug {
    TransactionNotFound = "transaction-not-found",
    JobNotFound = "job-not-found",
    SubstanceNotFound = "substance-not-found",
    TeamSettingsNotFound = "team-settings-not-found",
    WebhookDeliveryNotFound = "webhook-delivery-not-found",
    ArtifactNotFound = "artifact-not-found",
    UserNotFound = "user-not-found",
    ExtractionModelNotFound = "extraction-model-not-found",
    ValidationNotFound = "validation-not-found",
    ResourceNotFound = "resource-not-found",
    RequestValidationFailed = "request-validation-failed",
    FileValidationFailed = "file-validation-failed",
    HazcheckValidationFailed = "hazcheck-validation-failed",
    FeedbackValidationFailed = "feedback-validation-failed",
    JobAlreadyClaimed = "job-already-claimed",
    TeamSettingsAlreadyExists = "team-settings-already-exists",
    ExtractionModelCodeNameTaken = "extraction-model-code-name-taken",
    ExtractionModelInUse = "extraction-model-in-use",
    JobNotCancellable = "job-not-cancellable",
    JobNotRetryable = "job-not-retryable",
    ExportDestinationMismatch = "export-destination-mismatch",
    RemovalNotAcknowledged = "removal-not-acknowledged",
    TransactionExtracting = "transaction-extracting",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    TeamScopeViolation = "team-scope-violation",
    TeamNotAssigned = "team-not-assigned",
    HazcheckNotConfigured = "hazcheck-not-configured",
    GeminiUnavailable = "gemini-unavailable",
    GeminiTimeout = "gemini-timeout",
    OpenAiUnavailable = "openai-unavailable",
    QwenUnavailable = "qwen-unavailable",
    QwenResponseInvalid = "qwen-response-invalid",
    QwenSchemaVersionMismatch = "qwen-schema-version-mismatch",
    HazcheckUnavailable = "hazcheck-unavailable",
    HazcheckTimeout = "hazcheck-timeout",
    StorageUnavailable = "storage-unavailable",
    SupportDeskUnavailable = "support-desk-unavailable",
    ExtractionFailed = "extraction-failed",
    WebhookDeliveryTimeout = "webhook-delivery-timeout",
    WebhookDeliveryConnectionFailed = "webhook-delivery-connection-failed",
    WebhookDeliveryRejected = "webhook-delivery-rejected",
    WebhookDeliveryCustomerError = "webhook-delivery-customer-error",
    WebhookDeliveryPayloadTooLarge = "webhook-delivery-payload-too-large",
    WebhookDeliveryAbandoned = "webhook-delivery-abandoned",
    WebhookDeliveryNotConfigured = "webhook-delivery-not-configured",
    WebhookDeliveryTokenFailed = "webhook-delivery-token-failed",
    InternalServerError = "internal-server-error"
}
export enum RequirementAnswer {
    No = "no",
    Yes = "yes",
    IfMarinePollutant = "ifMarinePollutant"
}
export enum SailingMode {
    Cargo = 0,
    Passenger = 1
}
export enum SubstanceVerificationStatus {
    NoMatch = "noMatch",
    ExactMatch = "exactMatch",
    MultipleMatches = "multipleMatches",
    Error = "error"
}
export enum TargetSaveAction {
    Merge = "merge",
    Replace = "replace",
    Infer = "infer"
}
export enum TimeSeriesGrouping {
    None = 0,
    Day = 1,
    Week = 2,
    Month = 3
}
export enum TransactionNameSource {
    Filename = 0,
    BookingNumber = 1
}
export enum TransactionStatus {
    Uploaded = "uploaded",
    Extracting = "extracting",
    Extracted = "extracted",
    Curating = "curating",
    Curated = "curated",
    Validating = "validating",
    Validated = "validated",
    Completed = "completed",
    Failed = "failed"
}
export enum UnitType {
    OpenUnit = 1,
    ClosedUnit = 2,
    TankUnit = 3,
    Reefer = 4,
    Heated = 5,
    BulkOpen = 6,
    BulkClosed = 7
}
export enum WarningKey {
    BookingNumber = "bookingNumber",
    ShipperName = "shipper.name",
    ConsigneeName = "consignee.name",
    FreightForwarderName = "freightForwarder.name",
    VesselName = "vesselName",
    VoyageNumber = "voyageNumber",
    PortOfLoading = "portOfLoading",
    PortOfDischarge = "portOfDischarge",
    ContainerNumber = "containerNumber",
    SealNumber = "sealNumber",
    PackingCertificateSigned = "containerPackingCertificate.signed",
    PackingCertificateSignatoryName = "containerPackingCertificate.signatoryName",
    DeclarationSigned = "declaration.signed",
    DeclarationSignatoryName = "declaration.signatoryName"
}
export enum WebhookAuthType {
    None = 0,
    BearerToken = 1,
    OAuth2 = 2
}
export enum WebhookDeliveryStatus {
    Pending = "Pending",
    Delivering = "Delivering",
    Delivered = "Delivered",
    Failed = "Failed"
}
export enum WebhookEvent {
    ExtractionCompleted = "ExtractionCompleted",
    ValidationCompleted = "ValidationCompleted",
    TransactionSaved = "TransactionSaved",
    DocumentExported = "DocumentExported"
}
export type operations = Record<string, never>;
